
import React, { Component } from 'react';
import { Storage, API, graphqlOperation, Auth } from "aws-amplify";
import { createImage, deleteImage, updateImage, updateVideo, createVideo, deleteVideo } from '../graphql/mutations';
import { getUser } from '../graphql/queries';
import { getMatchImages } from '../utils/customQueries';
import { appendToFilename, getFileNameFromUrl, buildS3Url, 
    formatBytes, getSignedUrl, getJsonObject } from '../utils/functions';
import aws_exports from '../aws-exports';
import Toast from 'light-toast';
import VideoPlayer from '../components/videoPlayer';
import Datepicker from '../components/datepicker';
import "../App.css";
// import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
// import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import PauseCircleOutlineOutlinedIcon from '@material-ui/icons/PauseCircleOutlineOutlined';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@material-ui/icons/RemoveCircleOutlineOutlined';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
// import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import VideocamOutlinedIcon from '@material-ui/icons/VideocamOutlined';
import FeaturedVideoOutlinedIcon from '@material-ui/icons/FeaturedVideoOutlined';
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined';
// import FullscreenIcon from '@material-ui/icons/Fullscreen';
import AddIcon from '@material-ui/icons/Add';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
// import ArchiveIcon from '@material-ui/icons/Archive';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import Tooltip from '@material-ui/core/Tooltip';
import { HtmlTooltip } from '../utils/customThemes';
// import ModalImage from "react-modal-image";
import { Divider as SemanticDivider, Icon, Dropdown, Message, Progress } from 'semantic-ui-react';
// import AlertDialogSlide from '../components/alert';
import Table from '../components/smallTable';
// import Divider from '../components/divider';
import Switch from '../components/switch';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
// import { UserContext } from '../App';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import moment from 'moment';
import ImageGallery from 'react-image-gallery';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
// import TextField from '@material-ui/core/TextField';
import Slide from '@material-ui/core/Slide';
import { FEEDS, FEEDS_SPORTFIVE_5_FEED_MODEL, DATE_5_FEED_MODEL,
    CHECK_SINGLE_SESSION, MEDIA_BUCKET,
    DAYS_FULLLENGTH_VISIBLE_TO_CLIENTS, DISPLAY_NEW_FEATURES_1_4_4, 
    HUB_FEEDS, RESIZE_LAMBDA_NAME, RESIZE_LAMBDA_PATH, VIDEO_PATHS_FILE,
    UPLOAD_PREFIX, HIGHLIGHT_PREFIX, VIDEO_PREFIX } from '../utils/constants';
import { withMobileDialog } from '@material-ui/core';


const AWS = require('aws-sdk');
AWS.config.update ({
    region: aws_exports.aws_project_region
});
let S3;
const THEME = 'infront'; // TODO: import from constants.js

// const FileDownload = require('js-file-download');
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
class Panel extends Component {
    constructor(props) {
        super(props);
        this._imageGallery = null;
        this.videoRef = React.createRef();
        this.dropdownRef = React.createRef();
        console.log(props)
        // let's use it as a class variable, as we need this calculation only once
        this.dropdownCompanies = this.props.companies.map((company, index) => {
            return { key: company.id, value: company.id, text: company.name }
        });

        // video upload ref
        this.fileInput = React.createRef();
        this.handleUploadVideo = this.handleUploadVideo.bind(this);

        // image gallery
        this.setImageRef = element => {
            this._imageGallery = element;
        };
        this.state = {
            image: "",
            index: 0,
            matchInfo: null,
            matchId: props.matchId,
            images: null, 
            galleryImages: null,
            videoView: true,
            fileName: "",
            openConfirm: false,
            openCofirmVideo: false,
            openAddVimeoVideo: false,
            selectedVideo: {file: '', size: '', name: ''},
            // first in alphabetical order. If there are no companies => ALL is default
            value: this.dropdownCompanies.length > 0 ? this.dropdownCompanies[0].value : null,
            uploading: false,
            chunk: 0,
            chunksNumber: 0,
            progressBarLabel: "Reading file...",
            uploadId: null,
            uploadAborted: false,
            uploadAbortInitiated: false,
            signedURL: 'https://somevideo.vid',
            isFullMatchMode: false,
            videoToWorkWith: null,
            clientsAssignedToFullVideo: []
        };
    };
    openConfirmDelete = () => { this.setState({ openConfirm : true }); }
    closeConfirmDelete = () => { this.setState({ openConfirm : false }); }
    openConfirmDeleteVideo = (video) => { console.log("CLICK DELETE"); this.setState({ openConfirmVideo : true, videoToWorkWith: video }); }
    // closeConfirmDeleteVideo = () => { this.setState({ openConfirmVideo : false }); }
    closeConfirmDeleteVideo = () => { this.setState({ openConfirmVideo : false }); }
    openAddVimeoVideo = () => { this.setState({ openAddVimeoVideo : true }); }
    closeAddVimeoVideo = () => { this.setState({ openAddVimeoVideo : false }); }

    async componentDidMount() {
        const credentials = await Auth.currentCredentials();
        S3 = new AWS.S3({ 
            signatureVersion: 'v4', 
            httpOptions: { timeout: 0 },
            credentials: Auth.essentialCredentials(credentials) 
        });

        if (CHECK_SINGLE_SESSION && !this.props.user.isManager) {
            const input = { id: this.props.user.id };
            const userDbRecord = await API.graphql(
                graphqlOperation(getUser, input)
            );
            console.log(userDbRecord);
            let acquiredToken = this.props.user.refreshToken;
            if (acquiredToken) {
                console.log(this.props.user);
                console.log(acquiredToken);
            }
            else {
                const user = await Auth.currentAuthenticatedUser();
                console.log(user);
                acquiredToken = user.signInUserSession.refreshToken.token;
            }
            
            if (userDbRecord.data.getUser.token !== null &&
                userDbRecord.data.getUser.token !== acquiredToken) {
                    Toast.info(`Signed in from another device. Logging out...`, 2000);
                    console.log("Signed in from another device. Logging out...", userDbRecord.data.getUser.token);
                    Auth.signOut()
                    .then(data => console.log(data))
                    .catch(err => console.log(err));
                    return;
            }
        }
        console.log(this.props)
        const res = await this.getMatchImages(this.props.matchId);
    };

    async componentDidUpdate(prevProps, prevState) {
        // if (prevState.value !== this.state.value) {
        //     console.log('value state has changed.')
        //     if (this.state.minuteAllocation) {
        //         const offset = (this.props.feed - 1) * 2;
        //         if (minuteAllocation) {
                    
        //             for (const row of minuteAllocation) {
        //                 if (row[0] === value) {
        //                     soldMinutes = row[1 + offset];
        //                     playedMinutes = row[2 + offset];

        //                     console.log(row);
        //                 }
        //             }
        //             console.log(this.state.minuteAllocation);
        //             console.log(value);
        //         }

        //         this.setState({test: this.state.value})
        //     }
        //   }
        // console.log("did update", prevProps);
        // if (prevProps.feed !== this.props.feed) {
            // console.log(this.state.clientsAssignedToFullVideo);
            // this.state.videos
            // for (let video of videos) {
            //     video.signedUrl = await getSignedUrl(video.key);
            //     if (video.extra === "F" && video.company) {
            //         clientsAssignedToFullVideo.push(video.company.id);
            //     }
            // }
            // this.setState({feed: this.props.feed})
        // }
        // console.log(this.state)
        // if(this.state.videoView && this.state.videos)
        //     await this.setCurrentVideosSignedUrls(this.state.videos);
    }
    // async setCurrentVideosSignedUrls(videos) {
    //     this.signedUrls = [];
    //     for (let video of videos) {
    //         let signedUrl = await getSignedUrl(video.key);
    //         this.signedUrls.push({ key: video.key, signedUrl });
    //     }
    // }
    getMinuteAllocation = async () => {
        const bucket = aws_exports.aws_user_files_s3_bucket;   
        const key = `events/${this.props.matchId}/minutes.csv`;
        const options = {
            Bucket: bucket,
            Key: key,
            // ResponseContentType: 'application/json',
            ResponseCacheControl: 'No-cache'            // ensure json file is not cached
        };
        
        try {
            // const result = await S3.headObject(options).promise();
            // console.log(result)
            // console.log("Minute allocation file found in S3");
            const data = await S3.getObject(options).promise();
            const content = data.Body.toString('utf-8');
            let minuteAllocation = [];
            var rows = content.split(/\r\n|\n/);
            const numberOfFeeds = Object.keys(this.props.FEEDS).length;
            const numberOfColumns = (numberOfFeeds * 2) + 1;
            for (const row of rows) {
                if (row.length >= numberOfColumns) {
                    //const cells = row.split(",");
                    const cells = row.replaceAll(";", ",").split(","); // take into accout ";" as delimiter
                    const companyId = this.parseJsonCompany(cells[0]);
                    
                    // add the row only if the company IS in the companyList 
                    if (companyId) {
                        //minuteAllocation.push([companyId, cells[5], cells[8], cells[1], cells[4], cells[9], cells[12], cells[13], cells[16]]);
                        // new format (2 columns per feed)
                        if (numberOfFeeds === 5) // 5 feed model
                            minuteAllocation.push([companyId, cells[1], cells[2], cells[3], cells[4], cells[5], cells[6], cells[7], cells[8], cells[9], cells[10]]);
                        else
                            minuteAllocation.push([companyId, cells[3], cells[4], cells[1], cells[2], cells[5], cells[6], cells[7], cells[8]]);
                    }
                }
            }
            // console.log(minuteAllocation);
            return minuteAllocation;

            // console.log(options, data);
        } catch (err) {
            console.log("Minute allocation file not found or doesn't exist");
        }
        
    }
    getUnconfirmedVideosFromJson = async (matchName) => {
        const videoPathsFile = await getJsonObject(MEDIA_BUCKET, VIDEO_PATHS_FILE);
        
        // no VIDEO_PATHS_FILE found
        if (!videoPathsFile) {
            console.log("WARNING! Video paths JSON file not found");
            return null;
        }
        const matchAutoUploadedVideos = videoPathsFile.find(
            match =>  match.match_name.replace(/&#39;/g, "'").startsWith(matchName));
        
        return matchAutoUploadedVideos;
    }
    
    getMatchImages = async (id) => {
        try {
            const input = { id };
            const result = await API.graphql(
                graphqlOperation(getMatchImages, input )
            );
            let galleryImages = [];
            if (result.data.getMatch.date > DATE_5_FEED_MODEL) {
                console.log("NEW FEEDS");
            }
            result.data.getMatch.images.items.map((image) => {
                const origUrl = buildS3Url(image, true);
                const thumbUrl = buildS3Url(image, false);
                let size = "";
                let resolution = "";
                
                if (image.fullsize.size)
                    size = formatBytes(image.fullsize.size);
                if (image.fullsize.width)
                    resolution = image.fullsize.width + " x " + image.fullsize.height;
                
                galleryImages.push({
                    original: origUrl,
                    thumbnail: thumbUrl,
                    id: image.id,
                    name: image.fullsize.type ? image.fullsize.type.substr(-20) : origUrl.split("/").pop().substr(-20),
                    resolution: resolution,
                    size: size,
                    feedNumber: image.feedNumber,
                    company: image.company ? image.company.id : null
                });
            });
            let videos = result.data.getMatch.videos.items;
            



            /////////////// TODO !!!!!!!!!!!!!!
            //////////////////////////////////////
            ////// CHANGE THIS!!!!
            //////////////////////////////////////
            /// MAKE DEPENDABLE OF FEEDS constant
            let clientsAssignedToFullVideo = THEME === "sportfive" ? [[],[],[],[]] : [[],[],[],[],[]];

            const numberOfFeeds = Object.keys(this.props.FEEDS).length;
            if (numberOfFeeds === 5)
                clientsAssignedToFullVideo = [[],[],[],[],[]]
            // try Array(numberOfFeeds).fill([]) or new Array(numberOfFeeds).fill([])

            // TODO: investigate, why the solution to create array via Array().fill()
            // causes warnings in browser in Fulllength video mode
            // const clientsAssignedToFullVideo = Array(numberOfFeeds).fill([]);
            console.log(clientsAssignedToFullVideo);
            //////////////////////////////////////
            //////////////////////////////////////
            //////////////////////////////////////
            //////////////////////////////////////



            // get list of feeds that don't have a full-length video
            let feedsWithFullVideos = []; // will be re-used multiple times within this function
            videos.map((video) => {
                if (video.extra === 'F' && !video.company)
                    feedsWithFullVideos.push(video.feedNumber);
            });
            //console.log(feedsWithFullVideos);
            
            // ----------------------
            // check video.json
            // ----------------------
            

            let matchAutoUploadedVideos = await this.getUnconfirmedVideosFromJson(result.data.getMatch.details);           
            
            // if file exists and contains this match
            if (matchAutoUploadedVideos) {
                
                // handle unconfirmed full-length records
                matchAutoUploadedVideos.recordings.map((video) => {
                    const integerFeedNumber = this.parseJsonFeed(video.feed);
                    if (!feedsWithFullVideos.includes(integerFeedNumber)) {
                        console.log(`${video.feed}: unconfirmed recording`);
                        videos.push({
                            extra: "F", 
                            key: video.key,
                            feedNumber: integerFeedNumber
                        })
                    }
                });
                
                const newHighlights = [];
                // handle unconfirmed highlights
                matchAutoUploadedVideos.highlights.map((highlight) => {
                    const companyId = this.parseJsonCompany(highlight.brand_name);
                    const integerFeedNumber = this.parseJsonFeed(highlight.feed);
                    
                    // parsed brand not found in the list of companies added to DB
                    if (!companyId) {
                        console.log(`${highlight.feed}-${highlight.brand_name}: skipped`);
                        return;
                    }

                    // check if there is already a highlight for this company and feed
                    const foundIndex = videos.findIndex(video => video.company && // skip "no-company" full videos
                        video.extra === "H" &&
                        video.company.id === companyId &&
                        parseInt(video.feedNumber) === integerFeedNumber
                    );

                    if (foundIndex === -1) {
                        videos.push({            ///// 03.01 comment this out
                            extra: "H",
                            company: { id: companyId },
                            key: highlight.key,
                            feedNumber: integerFeedNumber
                        });                     /////// 03.01 comment out until here
                        newHighlights.push({   ///// 03.01 and uncomment this instead
                            extra: "H",
                            company: { id: companyId },
                            key: highlight.key,
                            feedNumber: integerFeedNumber
                        });                  /////// 03.01 uncomment until here
                    }
                    // else {
                    //     console.log(`Highlight already confirmed for ${highlight.feed}: ${highlight.brand_name}`);
                    // }
                });
                
                ////// 03.01 - uncomment from here   

                const newVideos = [];
                // videos.push(...newHighlights);
                // //Toast.loading(`Adding highlight videos...`);
                for (const highlight of newHighlights) {
                    const input = {
                        videoMatchId: this.props.matchId,
                        feedNumber: highlight.feedNumber,
                        videoCompanyId: highlight.company.id,
                        key: highlight.key,
                        extra: "H"
                    }
                     //if (input.feedNumber === 5) {// || input.feedNumber === 1 || input.feedNumber === 2 ) {
                        console.log(input);
                        

                        
                        const result = await API.graphql(
                            graphqlOperation(createVideo, { input })
                        );
                        console.log(result);
                        
                        // newVideos.push(result.data.createVideo); // new item added to db
                     //}
                }
                // //Toast.success("Success", 1000);
                // videos.push(...[newVideos]);
                
                ////// 03.01 - up until here
            }
            
            // match hasn't been found in video.json
            // proceed with scanning upload/ (if at least one full-length is missing) and highlight/

            else {
                
            // are there full-length videos available for all feeds? 
            // If not, we will proceed with checking for auto-uploads
            
            
            if (feedsWithFullVideos.length === Object.keys(this.props.FEEDS).length)
                console.log("All feeds have full-length records. OK.")
            
            else {
                // manage auto-uploaded videos and jsons
                const uploadDirParams = {
                    Bucket: MEDIA_BUCKET,
                    MaxKeys: 500,
                    Prefix: UPLOAD_PREFIX,
                };
                const currentMatchName = result.data.getMatch.details;

                try {
                    const uploadFolderFiles = await S3.listObjectsV2(uploadDirParams).promise();
                    console.log("upload dir contents", uploadFolderFiles.Contents);
                    for (let s3Object of uploadFolderFiles.Contents) {
                        const fileExtension = s3Object.Key.split('.').pop();

                        // read json file
                        if (fileExtension === 'json' && s3Object.Size < 2*1024*1024) { // read only files smaller than 2MB
                            const options = {
                                Bucket: MEDIA_BUCKET,
                                Key: s3Object.Key,
                                ResponseContentType: 'application/json'
                            };
                            const data = await S3.getObject(options).promise();
                            const arr = data.Body;
                            let str = "";
                            for (let i = 0; i < arr.byteLength; i++) {
                                str += String.fromCharCode(arr[i]);
                            }
                            const jsonParsedContents = JSON.parse(str);
                           
                            let jsonMatchName = "";
                            if ("match_name" in jsonParsedContents) {
                                jsonMatchName = jsonParsedContents.match_name;
                            }
                            else if ("event_name" in jsonParsedContents) {
                                jsonMatchName = jsonParsedContents.event_name;
                            }
                            else
                                console.log("no event_name, no_ match_name");

                            const jsonFeedName = jsonParsedContents.output_feed;
                            console.log("match: ", jsonMatchName);
                            // replace any '-chars
                            jsonMatchName = jsonMatchName.replace(/&#39;/g, "'");
                            if (jsonMatchName.includes(currentMatchName)) {
                                for (const [feedNumber, feedName] of Object.entries(this.props.HUB_FEEDS)) {
                                    if (feedsWithFullVideos.includes(parseInt(feedNumber)))
                                        console.log(feedNumber + "th feed has full-length video. Skipping.");
                                    else {
                                        if (jsonFeedName.includes(feedName)) {
                                            // ensure there's only one full-length per feed in upload/
                                            // Check whether such elements were added to videos
                                            const videoIndex = videos.findIndex(video => 
                                                !video.id && video.feedNumber === parseInt(feedNumber) 
                                                && video.extra === "F");                                            

                                            // if there are multiple same-feed full-length record in upload/,
                                            // leave the last one only. Remove earlier ones
                                            if (videoIndex > -1) {
                                                console.log(feedName, 
                                                    ": More than 1 full-length videos for this feed exists in upload folder. Ignoring the earlier one...");
                                                videos.splice(videoIndex, 1);
                                            }
                                            console.log("Adding a video into videos array for feed " + feedName);
                                            // auto-uploaded video
                                            videos.push({
                                                extra: "F", 
                                                key: s3Object.Key.substr(0, s3Object.Key.lastIndexOf(".")) + ".mp4",
                                                feedNumber: parseInt(feedNumber)
                                            })
                                        }
                                    }
                                }

                            }
                        } 
                    }
            
                } catch (error) {
                    console.log(error);
                }
            }

            const currentMatchName = result.data.getMatch.details;
            const highligthPrefix = HIGHLIGHT_PREFIX + currentMatchName.replaceAll(" ", "_");

            console.log("looking for highlights, using prefix ", highligthPrefix);
            const highlightDirParams = {
                Bucket: MEDIA_BUCKET,
                MaxKeys: 1000,
                Prefix: highligthPrefix,
            };

            try {
                const highligthFolderContents = await S3.listObjectsV2(highlightDirParams).promise();

                for (let s3Object of highligthFolderContents.Contents) {
                    const fileExtension = s3Object.Key.split('.').pop();

                    // read json file
                    if (fileExtension === 'json' && s3Object.Size < 1024*1024) { // read only files smaller than 1MB
                        const options = {
                            Bucket: MEDIA_BUCKET,
                            Key: s3Object.Key,
                            ResponseContentType: 'application/json'
                        };
                        const data = await S3.getObject(options).promise();
                        const arr = data.Body;
                        let str = "";
                        for (let i = 0; i < arr.byteLength; i++) {
                            str += String.fromCharCode(arr[i]);
                        }
                        const jsonParsedContents = JSON.parse(str);
                        const jsonFeedName = jsonParsedContents.output_feed;
                        const jsonBrandName = jsonParsedContents.brand_name;

                        const companyId = this.parseJsonCompany(jsonBrandName);
                        const feedNumber = this.parseJsonFeed(jsonFeedName);
                        console.log(`${this.props.HUB_FEEDS[feedNumber.toString()]}: ${jsonBrandName} (${companyId !== null})`);

                        if (companyId && feedNumber > 0)
                        {   
                            // make sure mp4-file exists and is bigger than 1 MB
                            const mp4FileKey = 
                                s3Object.Key.substr(0, s3Object.Key.lastIndexOf(".")) + ".mp4";

                            const mp4File = highligthFolderContents.Contents.find(obj =>
                                    obj.Key === mp4FileKey
                            );
                            const minLimitForMp4 = 1024*1024; // 1MB
                            if (!mp4File || mp4File.Size < minLimitForMp4) {
                                console.log("MP4 not found. Skipping.");
                                continue;
                            }

                            // ensure there are no highlights for this company and feed
                            const foundIndex = videos.findIndex(video => video.company && // skip "no-company" full videos
                                video.extra === "H" &&
                                video.company.id === companyId &&
                                parseInt(video.feedNumber) === feedNumber
                            );
                            if (foundIndex === -1)
                                // if no such highlight, add the auto-generated file to videos list
                                videos.push({
                                    extra: "H",
                                    company: {id: companyId},
                                    key: s3Object.Key.substr(0, s3Object.Key.lastIndexOf(".")) + ".mp4",
                                    feedNumber: feedNumber
                                });
                            // if more than 1 highlight for same feed were generated, remove the earlier one
                            else if (!videos[foundIndex].id) {
                                videos.splice(foundIndex, 1);
                                console.log(jsonBrandName, " has more than one highlight generated. Leaving the latest file")
                                videos.push({
                                    extra: "H",
                                    company: {id: companyId},
                                    key: s3Object.Key.substr(0, s3Object.Key.lastIndexOf(".")) + ".mp4",
                                    feedNumber: feedNumber
                                });
                            }
                            else
                                console.log(`A confirmed highlight exists for: ${this.props.HUB_FEEDS[feedNumber.toString()]} - ${jsonBrandName}`);
                        }

                    }
                }
            } catch (error) {
                console.log("Error while looking through highlight videos in S3: ", error);
            }
// json scan routine ends
 }
            for (let video of videos) {
                
                // auto-uploaded video
                if ((!video.id) || (video.key.startsWith(VIDEO_PREFIX) 
                    || video.key.startsWith(UPLOAD_PREFIX) || video.key.startsWith(HIGHLIGHT_PREFIX)))
                        video.signedUrl = await getSignedUrl(video.key, ""); // 22.11.20
                
                // manually uploaded video
                else
                    video.signedUrl = await getSignedUrl(video.key, VIDEO_PREFIX);
                
                if (video.extra === "F" && video.company) {
                    clientsAssignedToFullVideo[video.feedNumber-1].push(video.company.id);
                }
            }

            const NHL_ANALYTICS = true;
            const minuteAllocation = (DISPLAY_NEW_FEATURES_1_4_4 && !NHL_ANALYTICS) 
                ? await this.getMinuteAllocation() : null;

            this.setState({ 
                images: result.data.getMatch.images.items,
                videos,
                minuteAllocation,
                galleryImages,
                clientsAssignedToFullVideo,
                matchInfo: {
                    details: result.data.getMatch.details,
                    date: result.data.getMatch.date,
                    dateForUpload: moment(result.data.getMatch.date).format('YYYY-MM-DD'), // for upload
                    zipName: (result.data.getMatch.details + '_' +
                    result.data.getMatch.date.substring(0, 10)).replace(/[ ]|[/]/g, '_')
                }
             });
        } catch (err) {
            Toast.fail('Error fetching videos. Please, refresh the page', 3500, () => {
                console.log(err);
            });
        }
    }
    // this function is temp. Handles raw brand name. Returns company id 
    parseJsonCompany = (rawName) => {
        
        const s = rawName.toLowerCase();
        console.log(s);
        let name = null;
        
        if (s === "1&amp;1" || s === "1amp1" || s === "1&1") {
            name = "1&1";
        }
        else if (s.includes("rmann") && s.startsWith("h"))
            name = "Hörmann";
        else if (s.includes("renbacher") && s.startsWith("w"))
            name = "Würenbacher";
        else if (s.includes("lays"))
            name = "Lays";
        else if (s.startsWith("adidas"))
            name = "Adidas";
        else if (s.startsWith("danone"))
            name = "Danone";
        else if (s.startsWith("pepsi"))
            name = "Pepsi";
        else if (s.startsWith("espn"))
            name = "ESPN";
        else if (s.startsWith("nhl"))
            name = "NHL";
        else if (s.startsWith("betway"))
            name = "Betway";
        else if (s.startsWith("rogers"))
            name = "Rogers";
        else if (s.startsWith("ticketmaster"))
            name = "Ticketmaster";
        else if (s.includes("pintys"))
            name = "Pintys";
        else if (s.startsWith("chemours"))
            name = "Chemours";
        else if (s.startsWith("ppg"))
            name = "PPG";
        else if (s.startsWith("mgm"))
            name = "MGM";
        else if (s.startsWith("fanduel"))
            name = "FanDuel";
        else if (s.startsWith("sobey"))
            name = "Sobeys";
        else if (s === "bundesliga")
            name = "DFL";
        else if (s === "fcb endboard")
            name = "FC Bayern Munich";
        else if (s.startsWith("d3"))
            name = "D3 / D9";
        // else if (s === "signal iduna")  // ignore Signal Iduna (for now)
        //     return null;
        // else if (s === "signal iduna park") // instead, use Signal Iduna Park
        //     name = "Signal Iduna";
        else if (s === "yabosports" && THEME === "sportfive") {
            name = "YaboSports / BOB";
        }
        else
            name = s;

        const company = this.props.companies.find(
                company => company.name.toLowerCase() === name.toLowerCase());
        
        if (company)
            return company.id;
        else
            return null;
    }
    // parses json feed name. Returns feed number
    parseJsonFeed = (rawFeed) => {
        // const s = rawFeed.toLowerCase() // ?????? should we go lowercase. TODO double check
        let finalFeedNumber = 0;
        for (const [feedNumber, feedName] of Object.entries(this.props.HUB_FEEDS)) {
            if (rawFeed.includes(feedName))
                finalFeedNumber = feedNumber;
        }
        return parseInt(finalFeedNumber);
    }

    handleDeleteImage = async (imageId) => {
        this.setState({ openConfirm : false });
        const image = this.state.images.find(img => img.id === imageId);
        try {
            // delete physical image from S3 storage    
            if (image.fullsize)
                Storage.remove(image.fullsize.key)
                    .then(result => console.log(result))
                    .catch(err => console.log(err));
            if (image.thumbnail)
                Storage.remove(image.thumbnail.key)
                    .then(result => console.log(result))
                    .catch(err => console.log(err));
            else
                console.log("No thumbnail file was found");
            // delete from DB
            const input = {id: image.id};
            const result = await API.graphql(
                graphqlOperation(deleteImage, { input })
            );

            // delete from state
            const images = this.state.images.filter(
                el => el !== image
            );
            const galleryImages = this.state.galleryImages.filter(
                el => el.id !== image.id
            );
            
            // if (this.state.index > 0)
                // this.setState({ index: (this.state.index - 1) });
            this.setState({ images : images, galleryImages : galleryImages, index: 0 });
            this.props.updateChildPropsAfterChange(image, this.props.matchId, 'delete');
            Toast.success('Image deleted', 500, () => {
            });
        } catch (err) {
            Toast.fail('Error deleting image', 1500, () => {
                console.log(err);
          });
        }
    }

    handleDownloadImage = async (imageId) => {
        const key = this.state.images.find(img => img.id === imageId).fullsize.key;
        const downloadFile = (bytesArray, fileName) => {
            // npm install js-file-download --save
            // alternative
            //FileDownload(result.Body, fileName); 
            const blob = new Blob([bytesArray]);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
        }
        // Toast.loading('Saving to disk...');
        let fileName = getFileNameFromUrl(key);
        try {
            const publicKey = "public/" + key;
            const options = {
                Bucket: aws_exports.aws_user_files_s3_bucket,
                Key: publicKey,
                ResponseContentType: 'application/json'
            };      
            const data = await S3.getObject(options).promise();
            console.log(data.Body);
            downloadFile(data.Body, fileName);
            // Toast.hide();
        } catch (e) {
            throw new Error(`Could not retrieve file from S3: ${e.message}`)
        }
    }
    handleDownloadZip = async (feedOnly) => {
        let imagesToDownload;

        if (this.props.user.isManager) {
            imagesToDownload = feedOnly ?
                this.state.images.filter(image => image.feedNumber === this.props.feed)
                                    .filter(image => {
                                        // include "SHOW TO ALL" images (company=null)
                                        if (!image.company)
                                            return true;
                                        return image.company.id === this.state.value;
                                    })
                : this.state.images.filter(image => {
                    // include "SHOW TO ALL" images (company=null)
                    if (!image.company)
                        return true;
                    return image.company.id === this.state.value;
                });
        } else {
            imagesToDownload = feedOnly ?
                this.state.images.filter(image => image.feedNumber === this.props.feed)
                    .filter(image => {
                        // include "SHOW TO ALL" images (company=null)
                        if (!image.company)
                            return true;
                        return image.company.id === this.props.user.userCompany.id;
                    })
            : 
                this.state.images.filter(image => {
                    // include "SHOW TO ALL" images (company=null)
                    if (!image.company)
                        return true;
                    return image.company.id === this.props.user.userCompany.id;
                });
        }

        console.log(imagesToDownload);
        // TODO: just disable <download zip> button
        if (imagesToDownload.length === 0) {
            Toast.info(`No images yet`, 500, () => {});
            return true; // no images 
        }
        // Toast.loading('Zipping...');
        // fetch images' uint8Arrays from S3
        const getFilesDataAndFeeds = async (images) => {
            let filesData = [], key, feed;
            for(let i = 0; i < images.length; i++) {
                key = 'public/' + images[i].fullsize.key; // S3 methods need public/ in path
                feed = this.props.FEEDS[images[i].feedNumber].replace(/[ ]|[/]/g, '_'); // feed name
                let options = {
                    Bucket: aws_exports.aws_user_files_s3_bucket,
                    Key: key,
                    ResponseContentType: 'application/json'
                };
                let fileData = await S3.getObject(options).promise()
                    .then(result => {
                        return { 
                            arr: result.Body, 
                            name: getFileNameFromUrl(key),
                            feed: feed
                        }; 
                    })
                    .catch(err => console.log(err));
                console.log(fileData);
                filesData.push(fileData)
            }
            return filesData;
        }
        // zip fetched images and save archive package to disk
        const generateZip = async (filesData, matchInfo) => {         
            let zip = new JSZip();         
            // let folder = zip.folder(matchInfo).folder("feed");
            filesData.map((file) => {
                zip.folder(matchInfo).folder(file.feed).file(file.name, file.arr); //requires filesaver.js
            });
            zip.generateAsync({ type: 'blob' })
                       .then(function(content) {
                        saveAs(content, (matchInfo+".zip"));
                });
            return true;
        }
        const filesData = await getFilesDataAndFeeds(imagesToDownload);
        generateZip(filesData, this.state.matchInfo.zipName);
    };
    resizeImage = async(bucket, srcKey, dstKey, width) => {
        let success = false;
        try {
                const generateThumbnail = await API.put(RESIZE_LAMBDA_NAME, RESIZE_LAMBDA_PATH, {
                    body: {
                        bucket,
                        srcKey,
                        dstKey,
                        width
                    }
                });
                success = true;
        } catch (err) {
            Toast.info('Image will not be resized', 1500, () => {
                console.log(err);
          });
        }
        return success;
    }
    handleAddImage = async (files) => {
        const getUploadedFileDimensions = file => new Promise((resolve, reject) => {
            try {
                let img = new Image();
                img.onload = () => {
                    const width  = img.naturalWidth,
                          height = img.naturalHeight;
                    window.URL.revokeObjectURL(img.src);
                    return resolve({width, height});
                }
                img.src = window.URL.createObjectURL(file);
            } catch (exception) {
                return reject(exception);
            }
        });
        try {
            const suffix = '_' + moment().format('YYYY-MM-DD_HH-mm-ss').toString() + 
            '_' + this.props.feed.toString();
            const companyName = this.dropdownCompanies.find(company => company.value === this.state.value).text;            
            const prefix = this.state.matchInfo.dateForUpload + '_' + 
                this.state.matchInfo.details.replace(/[ ]|[/]/g, '_') + '/' + 
                companyName.replace(/[ ]|[/]/g, '_') + '/';
            const numberOfImagesToUpload = files.length;
            let uploadedImagesCounter = 0;
            let imagesFailedToUpload = 0;
            console.log(files);
            let newImages = [], newGalleryImages = [];
            if (numberOfImagesToUpload === 0) {
                console.log("No image selected");
                return;
            }
            else if (numberOfImagesToUpload === 1)
                Toast.loading(`Uploading image...`);
            else
                Toast.loading(`Uploading ${numberOfImagesToUpload} images...`);
            for (let file of files) {
                console.log(file);
                let fileDimensions = await getUploadedFileDimensions(file);
                if (!fileDimensions.width || !fileDimensions.height)
                    fileDimensions = {width: 0, height: 0};
                console.log(fileDimensions.width, fileDimensions.height);
                let fileSize = 0;
                if (file.size)
                    fileSize = parseInt(file.size);
                console.log(fileSize);
                if (fileSize > 15*1024*1024) {
                    imagesFailedToUpload++;
                    console.log("IMAGE SIZE EXCEEDS 15MB!!!");
                    continue;
                }
                
                uploadedImagesCounter++;
                const fullsizeName = appendToFilename(file.name, suffix, prefix);
                console.log(fullsizeName);

                const { identityId } = await Auth.currentCredentials(); // NEED ThIS AWAIT!! (no state otherwise) 
                // Storage.put adds '/public' prefix
                const uploadedFile = await Storage.put(fullsizeName, file, {
                    contentType: file.type
                });
                console.log(uploadedFile);
                const srcKey = 'public/' + uploadedFile.key;
                const resizeName = appendToFilename(fullsizeName, '_resized');
                const dstKey = 'public/' + resizeName;
                console.log(dstKey);
                const bucket = aws_exports.aws_user_files_s3_bucket;
                const width = 120;
                const resizeSuccess = await this.resizeImage(bucket, srcKey, dstKey, width);
                
                let thumbnail = {
                    key: resizeName
                }
                if (!resizeSuccess)
                    thumbnail = null;
                const fullsize = {
                    key: fullsizeName,
                    size: fileSize,
                    width: fileDimensions.width,
                    height: fileDimensions.height,
                    // just in case remember initial file name in the db
                    type: file.name // temporary we use "type" field to store it. TODO: replace with initialName
                };
                const input = 
                        {   
                            imageMatchId: this.props.matchId,
                            imageCompanyId: this.state.value,
                            fullsize: fullsize,
                            thumbnail: thumbnail,
                            bucket: aws_exports.aws_user_files_s3_bucket,
                            region: aws_exports.aws_project_region,
                            feedNumber: this.props.feed
                        } 
                const result = await API.graphql(
                    graphqlOperation(createImage, { input })
                );
                console.log(result);
                const newImage = result.data.createImage;
                newImages.push(newImage);
                const origUrl = buildS3Url(newImage, true);
                const thumbUrl = buildS3Url(newImage, false);
                let size = "";
                let resolution = "";
                if (newImage.fullsize.size)
                    size = formatBytes(newImage.fullsize.size);
                if (newImage.fullsize.width)
                    resolution = newImage.fullsize.width + " x " + newImage.fullsize.height;
                const newGalleryImage = {
                    original: origUrl,
                    thumbnail: thumbUrl,
                    id: newImage.id,
                    name: newImage.fullsize.type ? newImage.fullsize.type.substr(-20) : origUrl.split("/").pop().substr(-20),
                    resolution: resolution,
                    size: size,
                    feedNumber: newImage.feedNumber,
                    company: this.state.value
                }
                newGalleryImages.push(newGalleryImage);
            } // looping through files ends here

            // update the state
            // const newImage = result.data.createImage; // new item added to db
            this.setState({ images: [...this.state.images, ...newImages], 
                            galleryImages: [...this.state.galleryImages, ...newGalleryImages] });
            // this.setState({ isUploading: false });
            // Toast.hide();
            // this.setVariables(this.state.value);
            this.props.updateChildPropsAfterChange(newImages, this.props.matchId, 'add array');
            if (uploadedImagesCounter === 1)
                Toast.success(`Image successfully uploaded`, 500, () => {
                    console.log(newImages);
                });
            else
                Toast.success(`${uploadedImagesCounter} images successfully uploaded`, 900, () => {
                    console.log(newImages);
                });
            if (imagesFailedToUpload > 0)
                Toast.info(`${uploadedImagesCounter} image(s) wasn't uploaded! Its size exceeds the limit of 15MB`, 6000);
        } catch (err) {
            Toast.fail('Error adding image', 1500, () => {
                console.log(err);
            });
        }
    }
    // image change in the gallery
    onSlide(event) {
        const i = this._imageGallery.getCurrentIndex();
        this.setState({ index: i });
    }
    // switch image/video view
    changeView = (x) => {
      this.setState({ videoView: x });
    }
    // alternative way of video-image view change - click on label <Images> or <Videos>
    changeViewLabelClick = (videoView) => {
        this.setState({ videoView });
    }
    handleUpdateImage = async (image) => {
        console.log(image, image.id, this.state.value)
        console.log(this.props.companies)
        try {
            let input = {
                id: image.id,
                imageCompanyId: this.state.value
            }
            let result = await API.graphql(
                graphqlOperation(updateImage, { input })
            );
            console.log(result);
        } catch (err) {
            Toast.fail('Error updating image', 1500, () => {
                console.log(err.message);
          });
        }
    }
    // imageRefs = [];
    // setRef = (ref) => {
    //     this.imageRefs.push(ref);
    // };
    
    handleDeleteVideo = async () => {
        const video = this.state.videoToWorkWith;
        console.log(video);
        this.setState({ openConfirmVideo: false, videoToWorkWith: null });        

        try {
            // const video = userVideos[0];
            console.log(video);
            let deletedFullMatchVideosAssignedToClients = [];
            if (!video.company && video.extra === "F") {
                console.log("DELETE FULL MATCH VIDEO");
                const feedVideos = this.state.videos.filter(v => v.feedNumber === this.props.feed);

                // delete (from DB) full-length videos assigned to clients
                for (let v of feedVideos) {
                    if (v.extra === "F" && v.company) {
                        
                        // remember these videos ids to delete them later from state
                        deletedFullMatchVideosAssignedToClients.push(v.id);
                        
                        // delete from DB
                        const input = {
                            id: v.id
                        };
                        const result = await API.graphql(
                            graphqlOperation(deleteVideo, { input })
                        );
                        console.log(result);
                    }
                }
                // remove from state all assignments to this video 
                let clientsAssignedToFullVideo = [...this.state.clientsAssignedToFullVideo];
                const feed = parseInt(this.props.feed);
                clientsAssignedToFullVideo[feed - 1] = [];
                this.setState ({ clientsAssignedToFullVideo });
            }

            if (video.key) 
            {
                const keyPrefix = "video/";

                const publicKey = keyPrefix + video.key;
                const params = {
                    Bucket: MEDIA_BUCKET,
                    Key: publicKey,
                };
                const data = await S3.deleteObject(params).promise();
                console.log(data);

                // S3.deleteObject(params, function(err, data) {
                //     if (err) console.log(err, err.stack);  // error
                //     else     console.log("ok");                 // deleted
                //   });
            }

            // delete corresponding record from DB
            const input = {
                id: video.id
            };
            const result = await API.graphql(
                graphqlOperation(deleteVideo, { input })
            );
            console.log(result);
            
            // update state
            let videos;
            // if fullmatch videos assigned to clients were deleted, remove them from state as well
            if (deletedFullMatchVideosAssignedToClients.length > 0) {
                deletedFullMatchVideosAssignedToClients.push(video.id);
                console.log(deletedFullMatchVideosAssignedToClients);
                videos = this.state.videos.filter (
                    el => !deletedFullMatchVideosAssignedToClients.includes(el.id)
                    // el => el.id !== video.id 
                );
            }
            // only one highlight video (or full-length video without assignments) was deleted
            else
                videos = this.state.videos.filter(
                    el => el.id !== video.id 
                );
            this.setState({ videos });
            // this.setVariables(this.state.value);
            Toast.success('Video deleted', 700);
        } catch (err) {
            Toast.fail('Error deleting video', 1500, () => {
                console.log(err);
            });
        }
    }

    
    handleChangeDropdown = (e, { value }) => 
    {
        // this.setVariables(value);
        this.setState({ value });
    }

    handleRemoveSelection = () => {
        const selectedVideo = {
            size: '',
            name: '',
            modified: ''
        }
        this.setState({ selectedVideo });
    }
    
    handleAddVideo = async (fileName, timeTaken) => {
        console.log(fileName);
        console.log(Date.now());
        const { value } = this.state;
        try {
            const input = this.state.isFullMatchMode ? {
                        // "real" full-length videos are added to DB here,
                        // assigned full-length videos are added in handleAssignFullmatchVideoToClients()
                        videoMatchId: this.props.matchId,
                        feedNumber: this.props.feed,
                        key: fileName,
                        bucket: moment().startOf('day')
                            .add(DAYS_FULLLENGTH_VISIBLE_TO_CLIENTS, 'days').toDate().toString(),
                        extra: "F"
                    } 
                :
                    {
                        videoMatchId: this.props.matchId,
                        feedNumber: this.props.feed,
                        videoCompanyId: value,
                        key: fileName,
                        extra: "H"
                    }
                
            console.log(input);
            const result = await API.graphql(
                graphqlOperation(createVideo, { input })
            );
            console.log(result);
            
            // update state
            const newVideo = result.data.createVideo; // new item added to db
            
            
                        // 22.11.20
            // added temporarily (files for bayern-analytics are uploaded into video/bayern/)            
            const folderName = "video/";//THEME === "bayern" ? "video/bayern/" : "video/"
            newVideo.signedUrl = await getSignedUrl(fileName, folderName); // 22.11.20
            /////////


            this.setState({ videos: [...this.state.videos, newVideo], uploading: false,
                chunk: 0, chunksNumber: 0, progressBarLabel: "Reading file..." });
            // this.setVariables(this.state.value);
            // multipart upload done
            if (timeTaken) {
                const timeTakenFormatted = Math.floor(timeTaken / 60)+':'+Math.floor(timeTaken % 60);
                Toast.success(`Video uploaded. Time taken: ${timeTakenFormatted}`, 1900);
            }
            // normal upload done
            else
                Toast.success(`Video successfully added`, 900);
        } catch (err) {
            Toast.fail('Error creating database record for the uploaded video', 2000, () => {
                console.log(err.message);
          });
        }
    }

    handleUploadVideo(inputRef) {
    try {
        if (inputRef.current.files.length !== 1) {
            console.log("No files were selected");
            return;
        }
        const selectedVideo = {
            size: '',
            name: '',
            modified: ''
        }
  
        // code below is based on https://gist.github.com/sevastos/5804803
  
        const buffer = inputRef.current.files[0];

        // directory and file names in video bucket are built this way:
        // video/YY-MM-DD-MATCH_NAME/company_name_feedNumber_fileName_dateNow
        
        const companyName = this.state.isFullMatchMode ? 
            "FULL_LENGTH" :
            this.dropdownCompanies.find(company => company.value === this.state.value).text;
        const suffix = moment().format('YYYY-MM-DD_HH-mm-ss').toString();

        const prefix = this.state.matchInfo.dateForUpload + '_' + 
            this.state.matchInfo.details.replace(/[ ]|[/]/g, '_') + '/' + 
            companyName + '_' + this.props.feed.toString() + '_';

        const fileName = appendToFilename(buffer.name, suffix, prefix);
        // console.log(fileName);



        // 22.11.20
        // added temporarily (files for bayern-analytics are uploaded into video/bayern/)            
        const folderName = "video/";//THEME === "bayern" ? "video/bayern/" : "video/"
        const fileKey = folderName + fileName;  // 22.11.20
        ///////

        console.log(fileKey);
        const startTime = new Date();
        let partNum = 0;
        const megabyteSize = 1024 * 1024;
        const partSize = buffer.size > megabyteSize * 1024 ? megabyteSize * 20 : megabyteSize * 5; // Minimum 5MB per chunk (except the last part) http://docs.aws.amazon.com/AmazonS3/latest/API/mpUploadComplete.html
        console.log(partSize);
        // round upward to nearest integer, e.g. 3,2 will be rounded to 4
        var numPartsLeft = Math.ceil(buffer.size / partSize); 
        var maxUploadTries = 3;
        var multiPartParams = {
            Bucket: MEDIA_BUCKET,
            Key: fileKey, 
            ContentType: 'video/mp4'
        };
        var multipartMap = {
              Parts: []
        };

        console.log(numPartsLeft);
        console.log(buffer.size);
        console.log(buffer.size/partSize);
        
        const that = this;

        if (buffer.size < 10 * 1024 * 1024) {
        // if (partSize > buffer.size) {
            console.log("Size is smaller than 10MB");
            // Toast.info(`Can't upload videos smaller than 5MB`, 2000, () => {});
            // this.handleRemoveSelection();
            var params = {
                Bucket: MEDIA_BUCKET,
                Key: fileKey,
                ContentType: 'video/mp4',
                Body: buffer
            };
            
            // var options = {partSize: 10 * 1024 * 1024, queueSize: 1};
            Toast.loading("Uploading small video...");
            this.setState({ selectedVideo, uploading : true });
            S3.upload(params, function(err, data) {
                if (err) {
                    Toast.fail('An error occurred while uploading video', 2000, () => {
                        console.log("An error occurred while completing the upload");
                        console.log(err);
                    });
                  } else {
                    console.log('Final upload data:', data);
                    Toast.hide();
                    that.setState({ progressBarLabel: "Completing..." })
                    that.handleAddVideo(fileName);
                  }    
            });
            this.setState({ uploading : false });
            return;
        }
        var params = {
            Bucket: MEDIA_BUCKET,
            Key: fileKey,
            ContentType: 'video/mp4',
            Body: buffer
        };
        var upload = new AWS.S3.ManagedUpload({
            partSize: 10 * 1024 * 1024, queueSize: 4,
            params: params
        });
        // upload.send(function(err, data) {
        //     console.log(err, data);
        // });
        let progressUploaded = 0;
        // if (buffer.size > 10 * )

        this.setState({ uploadAborted: false, selectedVideo, uploadAbortInitiated: false,
            uploading: true, chunksNumber: 100, chunk: 0,
            progressBarLabel: "Uploading (0%)..." });

        upload.on('httpUploadProgress', function(evt) {
            let uploaded = Math.round(evt.loaded / evt.total * 100);
            console.log(`Progress: ${uploaded}%`);
            if (uploaded > progressUploaded) {
                if (that.state.uploadAbortInitiated) {
                    console.log("UPLOAD ABORT INITIATED");
                    console.log(this);
                    // this.setState({ uploading: false, progressBarLabel: "Uploading...", selectedVideo });
                    upload.abort();
                }
                progressUploaded = uploaded;
                // console.log("percent changed");
                that.setState({ chunk: progressUploaded, progressBarLabel: "Uploading (" + uploaded + "%)..." });
            }
        }).send(function(err, data) {
            if (err) {
                // an error occurred, handle the error
                console.log(err, err.stack);
                that.setState({ chunk: 0, uploading: false, uploadAbortInitiated: false, selectedVideo, progressBarLabel: "Uploading..." });
                if (err.name.includes("Abort")) // if RequestAbortedError -> don't show fail-message
                    return;
                Toast.fail('Could not upload video', 1500);
                return;
            }
        
            let fileUrl = data.Location;
            console.log('File URL:', fileUrl);
            console.log('File is uploaded successfully!');
            let delta = (new Date() - startTime) / 1000;
            console.log("time taken: ", delta);
            that.setState({ uploading : false, uploadAbortInitiated: false });
            that.handleAddVideo(fileName, delta);
        })

        // setTimeout(upload.abort.bind(upload), 1000);
        // return;
        // let progressBarLabel = (buffer.size < 20 * 1024 * 1024) ?
        //     `Preparing to upload`
        //     :
        //     `Reading the file. Upload will begin shortly`
        
        //     this.setState({ uploadAborted: false, uploadAbortInitiated: false,
        //     uploading: true, chunksNumber: numPartsLeft, 
        //     progressBarLabel });
            
        // const chunksNumber = numPartsLeft;
        // console.log("chunks number: ", chunksNumber);
        
        // let chunkCounter = 0;
        // // this.handleAddVideo(fileName);return;

        // function completeMultipartUpload(s3, doneParams) {
        //     s3.completeMultipartUpload(doneParams, function(err, data) {
        //       if (err) {
        //         Toast.fail('An error occurred while completing the multipart upload', 2000, () => {
        //             console.log("An error occurred while completing the multipart upload");
        //             console.log(err);
        //         });
        //       } else {
        //         var delta = (new Date() - startTime) / 1000;
        //         console.log('Completed upload in', delta, 'seconds');
        //         console.log('Final upload data:', data);
        //         that.handleAddVideo(fileName, delta);
        //       }
        //     });
        // }
        
        // function abortMultipartUpload(s3, params) {
        //     s3.abortMultipartUpload(params, function (err, data) {
        //         console.log(err, data);
        //         if (err) console.log(err, err.stack); // an error occurred
        //         else {
        //         console.log(data);           // successful response
        //         // window.location.reload();
        //         }
        //     });
        // }
        
        // /// zzzz
        // const uploadPart = (s3, multipart, partParams, tryNum) => {
        //     var tryNum = tryNum || 1;

        //     // console.log(that.state.uploadAbortInitiated, that.state.uploadAborted);

        //     s3.uploadPart(partParams, function(multiErr, mData) {

        //           if (that.state.uploadAbortInitiated) {
        //             console.log("Aborted");
        //             if (that.state.uploadAborted) {
        //                 console.log("already aborted. exiting...");
        //                 window.location.reload();
        //                 // return;
        //             }
        //             else {
        //                 const abortParams = {
        //                     Bucket: MEDIA_BUCKET,
        //                     Key: fileKey,
        //                     UploadId: multipart.UploadId
        //                 }
        //                 abortMultipartUpload(s3, abortParams);
    
        //                 that.setState({ uploading: false, selectedVideo, uploadId: null, 
        //                     uploadAborted: true,
        //                     chunk: 0, chunksNumber: 0, progressBarLabel: "Reading file..." });
        //             }
        //             // return;
        //           }

        //       if (multiErr) {
                
        //         if (that.state.uploadAbortInitiated) {
        //             console.log("upload aborted");
        //             return;
        //         }
        //         else
        //             console.log('multiErr, upload part error:', multiErr);
        //         if (tryNum < maxUploadTries) {
        //           console.log('Retrying upload of part: #', partParams.PartNumber);
        //           uploadPart(s3, multipart, partParams, tryNum + 1);
        //         } 
                
        //         // error
        //         else {
        //           console.log('Failed uploading part: #', partParams.PartNumber)
        //         }
        //         // that.setState({ uploading: false, uploadId: null,
        //         //     chunk: 0, chunksNumber: 0, progressBarLabel: "Reading file..." });
        //         // Toast.fail('Failed uploading video...', 3000);

        //         return;
        //       }


        //       multipartMap.Parts[this.request.params.PartNumber - 1] = {
        //         ETag: mData.ETag,
        //         PartNumber: Number(this.request.params.PartNumber)
        //       };
        //       console.log("Completed part", this.request.params.PartNumber);
        //       console.log('mData', mData);
  
        //       try {
        //         // let { chunk } = this.state;
        //         chunkCounter++;
        //         console.log(chunkCounter);
        //         console.log(numPartsLeft);
        //         let progressBarLabel;
        //         if (chunkCounter < chunksNumber) {
        //           const percentValue = chunkCounter / chunksNumber * 100;
        //           progressBarLabel = "Uploading (" + percentValue.toFixed(1) + "%)...";
        //         }
        //         else
        //           progressBarLabel = "Completing upload...";
                
        //         that.setState({ chunk : chunkCounter, progressBarLabel });
        //       } catch(e) {
        //           console.log(e);
        //       }
  
        //       if (--numPartsLeft > 0) return; // complete only when all parts uploaded
          
        //       var doneParams = {
        //         Bucket: MEDIA_BUCKET,
        //         Key: fileKey,
        //         MultipartUpload: multipartMap,
        //         UploadId: multipart.UploadId
        //       };
        //       that.setState({ selectedVideo });
        //       console.log("Completing upload...");
        //       completeMultipartUpload(s3, doneParams);
        //     });
        // }


        // // Multipart upload starts here
        // console.log("Creating multipart upload for:", fileKey);
        // S3.createMultipartUpload(multiPartParams, async function(mpErr, multipart) {
        //   if (mpErr) { 
        //     that.setState({ uploading: false, uploadId: null,
        //         chunk: 0, chunksNumber: 0, progressBarLabel: "Reading file..." });
        //     Toast.fail('Error while trying to launch multipart upload...', 3000);
        //     console.log('Error!', mpErr); 
        //     return; 
        //   }
        //   console.log("Got upload ID", multipart.UploadId);
        //   that.setState({ uploadId: multipart.UploadId });
        //   // Grab each partSize chunk and upload it as a part
        //   for (var rangeStart = 0; rangeStart < buffer.size; rangeStart += partSize) {
        //     console.log(rangeStart);
        //     partNum++;

        //     var end = Math.min(rangeStart + partSize, buffer.size),
        //         partParams = {
        //           Body: buffer.slice(rangeStart, end),
        //           Bucket: MEDIA_BUCKET,
        //           Key: fileKey,
        //           PartNumber: String(partNum),
        //           UploadId: multipart.UploadId
        //         };
            
        //     if (that.state.uploadAbortInitiated) {
        //         console.log("Aborted");
        //         // return;
        //     }

        //     // Send a single part
        //     console.log('Uploading part: #', partParams.PartNumber, ', Range start:', rangeStart);
        //     uploadPart(S3, multipart, partParams);

        //   } // end for-loop
        // });
        } catch (e) {
            this.setState({ uploading: false, uploadId: null,
                chunk: 0, chunksNumber: 0, progressBarLabel: "Reading file..." });
            Toast.fail('Could not upload video to S3', 3000);
            throw new Error(`Could not upload file to S3: ${e.message}`);
        }
    }
    
    handleCancelUpload = () => {
        this.setState({ uploadAbortInitiated: true });
        Toast.info(`Stopping upload... This may take a few seconds`, 2000);
        console.log("Upload abort initiated!");
    }

    handleSelectVideo(video) {
        if (!video) {
            console.log("no selection");
            return;
        }
        const selectedVideo = {
            size: formatBytes(video.size),
            name: video.name,
            modified: video.lastModified
        };
        console.log(video);
        console.log(selectedVideo);
        
        this.setState({ selectedVideo, uploadAborted: false, uploadAbortInitiated: false });
    
    }
    // prevent context menu on video
    handleRightClick(ev) {
        console.log(ev);
        ev.preventDefault()
    }


    handleSelectClientsToAssign = (e, {value}) => {
        // console.log(value);
        
        let clientsAssignedToFullVideo = [...this.state.clientsAssignedToFullVideo];
        const feed = parseInt(this.props.feed);
        clientsAssignedToFullVideo[feed - 1] = value;
        this.setState ({ clientsAssignedToFullVideo });
            
            // this.setState(prevState => ({
            //     clientsAssignedToFullVideo: {
            //         ...prevState.clientsAssignedToFullVideo,
            //         [prevState.clientsAssignedToFullVideo[feed-1]]: value,
            //     },
            // }));
    }
    handleAssignFullmatchVideoToClients = async (fullMatchVideo) => {
        // console.log(this.state.clientsAssignedToFullVideo);
        // console.log(fullMatchVideo);
        // console.log(fullMatchVideo);
        const feedVideos = this.state.videos.filter(v => v.feedNumber === this.props.feed);
        console.log("feed videos", feedVideos);
        try {
            const feed = parseInt(this.props.feed);
            console.log(this.state.clientsAssignedToFullVideo[feed-1])
            let old = [], added = this.state.clientsAssignedToFullVideo[feed-1],
                clientsToAddToAssignment = [], clientsToRemoveFromAssignment = [];

            for (let video of feedVideos) {
                if (video.extra === "F" && video.company) {
                    old.push(video.company.id);
                }
            }
            console.log("OLD", old);
            clientsToAddToAssignment = added.filter(item => old.map(c => c).indexOf(item) === -1);
            // companies removed by user
            clientsToRemoveFromAssignment = old.filter(item => added.map(c=>c).indexOf(item) === -1);
            console.log(clientsToAddToAssignment, clientsToRemoveFromAssignment);
            if(clientsToAddToAssignment.length === 0 && clientsToRemoveFromAssignment.length === 0) {
                Toast.info("No changes have been made", 500);
                return;
            }
            Toast.loading("Assigning full-length record to clients");
            const numberOfClientsToAssign = clientsToAddToAssignment.length;
            // Toast.loading(`Assigning full-length record to ${numberOfClientsToAssign} clients`);
            // adding videos
            for (let companyId of clientsToAddToAssignment) {
                const input = {
                            videoMatchId: this.props.matchId,
                            feedNumber: this.props.feed,
                            key: fullMatchVideo.key,
                            bucket: fullMatchVideo.bucket,
                            extra: "F",
                            videoCompanyId: companyId
                        } 

                const result = await API.graphql(
                    graphqlOperation(createVideo, { input })
                );
                
                let newClientVideo = result.data.createVideo;
                newClientVideo.signedUrl = fullMatchVideo.signedUrl;

                this.setState({videos: [...this.state.videos, newClientVideo ]});
            }

            // removing assignments...
            for (let companyId of clientsToRemoveFromAssignment) {
                const videoToRemove = feedVideos.filter(v => v.extra === "F")
                    .find(v => {
                        if (v.company) 
                            return v.company.id === companyId;
                });
                
                console.log(videoToRemove);
                if (videoToRemove) {
                    const input = {
                                id: videoToRemove.id
                    } 
                    
                    const result = await API.graphql(
                        graphqlOperation(deleteVideo, { input })
                    );

                    const videos = this.state.videos.filter(
                        el => el.id !== videoToRemove.id
                    );
                    this.setState({ videos });
                }
                else {
                    console.log("Can't find video to remove");
                }
            }
            // this.setState({ clientsAssignedToFullVideo: [] });
            // update state
            // const newVideo = result.data.createVideo; // new item added to db
            
            // this.setState({ videos: [...this.state.videos, newVideo], uploading: false,
            //     chunk: 0, chunksNumber: 0, progressBarLabel: "Reading file..." });
            // this.setVariables(this.state.value);
            Toast.success(`Visible to ${added.length} client(s)`, 900);
        } catch (err) {
            Toast.fail('Could not assign video to clients', 1800, () => {
                console.log(err.message);
          });
        }
    }

    // async myNewTest (key) {
    //     const url = await getSignedUrl(key);
    //     console.log(key);
    //     console.log(url);
    // }
    // testFunc = async(e) => {
    //     // e.preventDefault();
    //     console.log(this.videoRef.current);
    //     const getSignedUrlParams = {
    //         Bucket: MEDIA_BUCKET,
    //         Key: "video/test_video_20s_1599295050948.mp4",
    //         Expires: 3600
    //     };
    //     let signedURL = '';
    //     const that = this;
    //     S3.getSignedUrl('getObject', getSignedUrlParams, function(err, url) {
    //         if(err) {
    //             console.log("Error getting Signed Url: ", err);
    //             // process.exit(1);
    //             return;
    //         }
    //         console.log("Generated Signed Url: ", url);
    //         signedURL = url;
    //         that.setState({ signedURL });
    //         that.videoRef.current.play();
    //     });
    //     console.log(signedURL);
    // }
    // moving here some logic from render
    // setVariables() {}
    // setVariablesOld = async (value) => {
    //     let companyName, currentGalleryImages = [], currentVideos = [], 
    //     userHasVideo = false, userHasCommonVideo = false, userHasOwnVideo = false;
    //     console.log(this.state)
    //     if (value)
    //         companyName = this.dropdownCompanies.find(company => company.value === value).text;
        

    //     // managers see images that belongs to company selected in Dropdown (state.value)
    //     if (this.props.user.isManager) {
    //         currentGalleryImages = this.state.galleryImages
    //             .filter(image => image.feedNumber === this.props.feed)
    //             .filter(image => {
    //                 // let companyId = image.company ? image.company.id : null;
    //                 // console.log(image)
    //                 // console.log(image.company);
    //                 // console.log(value);
    //                 if (image.company)
    //                     return image.company === value;
    //                 else
    //                     return true;
    //                 // || image.company === null; // let's assume null is "SHOW TO ALL"
    //             });
    //         currentVideos = this.state.videos
    //             .filter(video => video.feedNumber === this.props.feed)
    //             .filter(video => {
    //                 // video has one client owner (not a common video)
    //                 if (video.company) {
    //                     if (video.company.id === value)
    //                         userHasOwnVideo = true;
    //                     return video.company.id === value;
    //                 }
    //                 // there's a common video (visible to ALL) in this feed
    //                 else {
    //                     userHasCommonVideo = true;
    //                     return true;
    //                 }

    //             });
    //         if (currentVideos.length > 0) {
    //             userHasVideo = true;
    //             // 1 own video + 1 common video
    //             // ensure own video comes first (at 0th position in array)
    //             if (currentVideos.length > 1) {
    //                 // swap 0th and 1st elements if common video is a [0] element
    //                 console.log("2 videos");
    //                 if (!currentVideos[0].company) {
    //                     let tmp = currentVideos[0];
    //                     currentVideos[0] = currentVideos[1]; 
    //                     currentVideos[1] = tmp;
    //                     console.log("swapping");
    //                 }
    //             }
    //         }
    //     }
    //     // client users can see only their company's images and "SHOW TO ALL" images
    //     else {
    //         // console.log(this.props.user.userCompany)
    //         // if client has no company, show only "SHOW TO ALL" images
    //         console.log(this.props.user)
    //         if (!this.props.user.userCompany) {
    //             currentGalleryImages = [];
                
    //             console.log("user has no company");
    //         }
    //         else {
    //             currentGalleryImages = this.state.galleryImages
    //                 .filter(image => image.feedNumber === this.props.feed)
    //                 .filter(image => {
    //                     // console.log(image.company);
    //                     if (image.company)
    //                         return this.props.user.userCompany.id === image.company;
    //                     else
    //                         return true;
    //             });
    //             currentVideos = this.state.videos
    //                 .filter(video => video.feedNumber === this.props.feed)
    //                 .filter(video => {
    //                     // let companyId = image.company ? image.company.id : null;
    //                     // console.log(image)
    //                     // console.log(image.company);
    //                     // console.log(value);
    //                     if (video.company)
    //                         return this.props.user.userCompany.id === video.company.id;
    //                     else   
    //                         return true;
    //                     // || image.company === null; // let's assume null is "SHOW TO ALL"
    //                 });
    //             if (currentVideos.length > 0)
    //                 userHasVideo = true;
    //             }
    //     }
    //     // generating signed urls for each video
    //     for (let i in currentVideos) {
    //         if (currentVideos[i].key && !currentVideos[i].signedUrl)
    //             currentVideos[i].signedUrl = await getSignedUrl(currentVideos[i].key);
    //     }

    //     this.setState({ companyName, currentGalleryImages, currentVideos, 
    //         userHasVideo, userHasCommonVideo, userHasOwnVideo });
    // }
    // handleChangeVideo = async(video) => {
    //     Toast.info("Feature is under development", 800);
    //     return;
    //     try {
    //         if(video.extra === "F")
    //             video.extra = "H";
    //         else
    //             video.extra = "F";
            
    //         let videos = [...this.state.videos];
    //         // // console.log(tableData);
    //         const index = videos.findIndex(v => v.id === video.id);
            
    //         // tableData[index] = updatedUser;
    //         const updatedVideos = [
    //             ...videos.slice(0, index),
    //             video,
    //             ...videos.slice(index + 1)
    //         ];
    //         let input = {
    //             id: video.id,
    //             extra: video.extra
    //         }
    //         let result = await API.graphql(
    //             graphqlOperation(updateVideo, { input })
    //         );
    //         console.log(result);

    //         this.setState({ videos: updatedVideos });
    //     } catch (e) {
    //         Toast.fail('Could not update video type', 1000);
    //         console.log(e);
    //     }

    // }
    // toggle Full-length/Highlight modes
    handleChangeFullMatchMode = () => {
        this.setState(prevState => ({
            isFullMatchMode: !prevState.isFullMatchMode
          }));
    };

    handleChangeDatepicker = async (newDate, video) => {
        // console.log(moment(newDate).format("DD.MM.YYYY"));
        // const t = newDate.toString();
        // console.log(t)
        // console.log(video)
        
        // console.log("datepicker output date: ", newDate);
        // console.log("state date: ", this.state.matchInfo.date);
        // const momentFormattedDate = moment(this.state.matchInfo.date)
            // .startOf('day').toDate().toString();
        // // const dayDate = new Date(momentFormattedDate).setHours(0,0,0,0);
        // console.log("formatted date from the state, without days addition", momentFormattedDate);
        // console.log(moment(this.state.matchInfo.date)
        //     .startOf('day').add(7, 'days').toDate().toString())
        // console.log(moment(newDate)
        //     .startOf('day').add(7, 'days').toDate().toString()) // to add 7 days
        // console.log(newDate.toString())                         // without 7 days addition
        // return
        // console.log(momentFormattedDate);
        // console.log(dayDate);
        // console.log(new Date(this.state.matchInfo.date).setHours(0,0,0,0))
        // console.log(new Date(newDate).setHours(0,0,0,0))
        // return
        // console.log(moment(newDate).format('DD-MM-YY'))
        // console.log(moment(new Date(t)).format('DD-MM-YY'))
        console.log(video);
        try {
            const formattedDate = newDate.toString();
            let videos = [...this.state.videos];

            video.bucket = newDate.toString();
            const index = videos.findIndex(v => v.id === video.id);

            const updatedVideos = [
                ...videos.slice(0, index),
                video,
                ...videos.slice(index + 1)
            ];

            let input = {
                id: video.id,
                bucket: formattedDate
            };

            let result = await API.graphql(
                graphqlOperation(updateVideo, { input })
            );
            console.log(result);
            Toast.success("Last availability date successfully modified", 800);

            this.setState({ videos: updatedVideos });
        } catch (e) {
            Toast.fail('Could not update last video availability date', 1000);
            console.log(e);
        }
    }

    handleManualUploadMode = (videoSignedUrl) => {
        this.setState({ 
            videos: this.state.videos.filter((video) => { 
                // return (video.id || (!video.id && video.feedNumber !== this.props.feed))
                return (video.id || video.signedUrl !== videoSignedUrl)
            })
        });
    }
    handleConfirmAutoUploadVideo = async (videoSignedUrl) => {
        ////// TODO!!!
        ///// Re-use handleAddVideo()
        //console.log(videoSignedUrl);

        const { value } = this.state;
        try {
            const videoIndex = this.state.videos
                .findIndex(video => !video.id && video.signedUrl === videoSignedUrl);

            console.log(videoIndex)
            if (videoIndex === -1) {
                console.log("Can't find video");
                return;
            }
            const fileName = this.state.videos[videoIndex].key;

            const input = this.state.isFullMatchMode ? {
                        // "real" full-length videos are added to DB here,
                        // assigned full-length videos are added in handleAssignFullmatchVideoToClients()
                        videoMatchId: this.props.matchId,
                        feedNumber: this.props.feed,
                        key: fileName,
                        bucket: moment().startOf('day')
                            .add(DAYS_FULLLENGTH_VISIBLE_TO_CLIENTS, 'days').toDate().toString(),
                        extra: "F"
                    } 
                :
                    {
                        videoMatchId: this.props.matchId,
                        feedNumber: this.props.feed,
                        videoCompanyId: value,
                        key: fileName,
                        extra: "H"
                    }
                
            console.log(input);
            const result = await API.graphql(
                graphqlOperation(createVideo, { input })
            );
            console.log(result);
            
            // update state
            const newVideo = result.data.createVideo; // new item added to db
            
            const folderName = "";
            newVideo.signedUrl = await getSignedUrl(fileName, folderName);
            
            const videos = [
                ...this.state.videos.slice(0, videoIndex),
                newVideo,
                ...this.state.videos.slice(videoIndex + 1)
              ];
            
            this.setState({ videos });
            
            Toast.success(`Video successfully added`, 900);
        } catch (err) {
            Toast.fail('Error creating database record for the uploaded video', 2000, () => {
                console.log(err.message);
          });
        }

    }
    testEmail = async (video) => {
        console.log(video);

        // Create sendEmail params 
var params = {
    Destination: { /* required */
      
      ToAddresses: [
        'oat.alexandru@gmail.com',
        /* more items */
      ]
    },
    Message: { /* required */
      Body: { /* required */
        Html: {
         Charset: "UTF-8",
         Data: "HTML_FORMAT_BODY"
        },
        Text: {
         Charset: "UTF-8",
         Data: "TEXT_FORMAT_BODY"
        }
       },
       Subject: {
        Charset: 'UTF-8',
        Data: 'New test email'
       }
      },
    Source: 'alexandru.oat@supponor.com', /* required */
    // ReplyToAddresses: [
    //    'alexandru.oat@supponor.com',
    //   /* more items */
    // ],
  };
  
  // Create the promise and SES service object
  var sendPromise = new AWS.SES({apiVersion: '2010-12-01'}).sendEmail(params).promise();
  //console.log(sendPromise);
  // Handle promise's fulfilled/rejected states
  sendPromise.then(
    function(data) {
      console.log(data.MessageId);
    }).catch(
      function(err) {
      console.error(err, err.stack);
    });


    }
    render () { 
        const { images, videos, matchInfo, videoView, value, 
            selectedVideo, chunk, isFullMatchMode, minuteAllocation } = this.state;
        let { index } = this.state;

        if (!images || !videos) 
            return (<div className="lds-dual-ring"></div>);
        else {
            //console.log(this.state.uploading, this.state);
            let isFullMatchVideoVisible = false;
            const feed = parseInt(this.props.feed);
            // console.log(this.dropdownCompanies)
            // console.log(videos.map(v => {
            //     if (v.company) {
            //         // console.log(v.company.id)
            //         console.log(this.dropdownCompanies.find(k => k.key === v.company.id).text)
            //         console.log(v)
            //     }
            //     }
            //     ))
            // console.log("assigned to clients (ids)", this.state.clientsAssignedToFullVideo[feed-1]);
            //console.log("match videos", videos);
            // console.log(this.state.clientsAssignedToFullVideo);
            let companyName, currentGalleryImages = [], currentVideos = [], highlightVideoNumber = 0, 
                userHasVideo = false, feedFullMatchVideo = null, userHasOwnVideo = false;

            if (value)
                companyName = this.dropdownCompanies.find(company => company.value === value).text;
    
            if (this.props.user.isManager) {
                currentGalleryImages = this.state.galleryImages
                    .filter(image => image.feedNumber === this.props.feed)
                    .filter(image => {
                        if (image.company)
                            return image.company === value;
                        // else
                        //     return false;
                        // || image.company === null; // let's assume null is "SHOW TO ALL"
                    });
                currentVideos = this.state.videos
                    .filter(video => video.feedNumber === this.props.feed)
                    .filter(video => {
                        
                        if (video.company) {
                            if (video.company.id === value)
                                userHasOwnVideo = true;
                            return video.company.id === value;
                        }
                        // there's a FullMatch video in this feed
                        else {
                            feedFullMatchVideo = video;
                            return false;
                        }
    
                    });
                
                if (currentVideos.length > 0) {
                    userHasVideo = true;
                    const fullMatchVideoIndex = currentVideos.findIndex(v => v.extra === "F");

                    // user has no fullMatch video
                    if (fullMatchVideoIndex === -1)
                        highlightVideoNumber = currentVideos.length;
                    
                    // user has fullMatch video and at least one highlight video 
                    else if (fullMatchVideoIndex !== -1 && currentVideos.length > 1) {
                        highlightVideoNumber = currentVideos.length - 1;

                        // ensure fullMatch video comes last
                        // console.log("INDEX", fullMatchVideoIndex);
                        // if fullMatch video isn't on the last place
                        if (currentVideos.length !== fullMatchVideoIndex + 1) {
                            // swap it with the last video in the list
                            let tmp = currentVideos[currentVideos.length-1];
                            currentVideos[currentVideos.length-1] = currentVideos[fullMatchVideoIndex];
                            currentVideos[fullMatchVideoIndex] = tmp;
                        }                    
                    }
                }
                // console.log("num of highlights", highlightVideoNumber);
            }
            
            // 20.10.20. Bug spotted: index isn't nullified when changing feeds.
            // As a result, activeGalleryImage was undefined. For now we set it to 0 
            // if it's greater than (number of current imgs for the feed - 1). TODO: IMPROVE!
            if (index > (currentGalleryImages.length - 1)) {
                index = 0;
                // console.log("Index {} was greater than the number of current feed images. Setting index to 0")
            }
            
            const feedHasImages = currentGalleryImages.length > 0;    
            const activeGalleryImageInfo = feedHasImages ? currentGalleryImages[index] : null;
            // console.log(feedHasImages, "feedHasImages");
            // console.log(activeGalleryImageInfo, "activeGlalery Image info");
            // console.log(index, currentGalleryImages, "index and currentGalleryImages");
            if (isFullMatchMode) {
                // console.log("Full match mode");
                if (feedFullMatchVideo) {
                    // console.log("there's a full match video in this feed", feedFullMatchVideo);
                    if (feedFullMatchVideo.bucket) { // TODO: remove this condition check
                        const lastVideoAvailabilityDate = new Date(feedFullMatchVideo.bucket);
                        // console.log(lastVideoAvailabilityDate);
                        // set time to 00:00:00 in today's date 
                        const today = new Date().setHours(0,0,0,0);
                        isFullMatchVideoVisible = lastVideoAvailabilityDate >= today;
                        console.log("is full-length visible? - ", isFullMatchVideoVisible);
                    }
                }
            }
            else {
                // console.log("Highlight mode");
                const clientFullMatchVideo = currentVideos.find(v => v.extra === "F");
                // will be undefined, if client has no fullMatch video
                if (clientFullMatchVideo) {
                    // console.log("Client has full match video");
                    if (clientFullMatchVideo.bucket) { // TODO: remove this condition check
                        const lastAssignedVideoAvailabilityDate = new Date(clientFullMatchVideo.bucket);
                        // console.log(lastVideoAvailabilityDate);
                        // set time to 00:00:00 in today's date 
                        const today = new Date().setHours(0,0,0,0);
                        isFullMatchVideoVisible = lastAssignedVideoAvailabilityDate >= today;
                        // console.log("is client's full-length visible? - ", isFullMatchVideoVisible);
                    }
                }
                // console.log(clientFullMatchVideo);
            }

            // MINUTE ALLOCATION
            // TODO: MOVE THIS TO componentDidUpdate() !!!
            let soldMinutes,
                playedMinutes;
            let soldValidated = false,
                playedValidated = false;

            const offset = (this.props.feed - 1) * 2;
            if (minuteAllocation) {
                
                for (const row of minuteAllocation) {
                    console.log(row.length, offset);
                    if (row[0] === value && row.length > (offset + 2)) {
                        
                        soldMinutes = row[offset + 1];
                        playedMinutes = row[offset + 2];
                        
                        // tmp. validation (TODO: MAKE A FUNC!!!)
                        if (soldMinutes.length === 5) {
                            const splitted = soldMinutes.split(':');

                            if (splitted.length === 2) {
                                const minutes = splitted[0];
                                const seconds = splitted[1];
             
                                const isMinutesNumber = /^\d+$/.test(minutes);
                                const isSecondsNumber = /^\d+$/.test(seconds);
                                // console.log(isMinutesNumber, isSecondsNumber);
             
                                const minutesInt = parseInt(minutes);
                                const secondsInt = parseInt(seconds);
                                //  console.log(minutesInt, secondsInt);

                                if (minutesInt <= 90 && minutesInt >= 0 && 
                                    secondsInt >= 0 && secondsInt < 60 &&
                                    isMinutesNumber && isSecondsNumber)
                                  
                                    soldValidated = true;
                            }
                        }
                        if (playedMinutes.length === 5) {
                            const splitted = playedMinutes.split(':');

                            if (splitted.length === 2) {
                                const minutes = splitted[0];
                                const seconds = splitted[1];
             
                                const isMinutesNumber = /^\d+$/.test(minutes);
                                const isSecondsNumber = /^\d+$/.test(seconds);
                                // console.log(isMinutesNumber, isSecondsNumber);
             
                                const minutesInt = parseInt(minutes);
                                const secondsInt = parseInt(seconds);
                                //  console.log(minutesInt, secondsInt);

                                if (minutesInt <= 90 && minutesInt >= 0 && 
                                    secondsInt >= 0 && secondsInt < 60 &&
                                    isMinutesNumber && isSecondsNumber)
                                  
                                    playedValidated = true;
                            }
                        }
                        console.log(soldValidated, playedValidated);
                        console.log(row);
                    }
                }
                //console.log(this.state.minuteAllocation);
                if (!soldValidated) soldMinutes = '';
                if (!playedValidated) playedMinutes = '';
                //console.log(value);
            }
            // TODO: MOVE TO companyDidUpdate() !!!
            // MINUTE ALLOCATION ENDS

            return (

            <div className="panelDialogMain">
              {this.props.user.isManager ?
                  <div className="galleryViewPanelDialogMain">
                  
                    {videoView ?

// MANAGER - LEFT - VIDEO
                    
                    <div className="galleryViewLeftSide">
{/* --- video is uploading */}
                    {this.state.uploading ? 
                        <div className="progressBar">
                        <Progress value={chunk} 
                            active size='large' color='teal' 
                            total={this.state.chunksNumber}  
                        />
                        <Message
                                compact
                                icon='circle notched loading'
                                className='progressBarLabelWithIcon'
                                content={this.state.progressBarLabel}
                        />
                        <br/>
                        <Button
                            variant="contained"
                            size="small"
                            disableElevation
                            className="panelDialogButton widerButton"
                            onClick={this.handleCancelUpload}
                            startIcon={<CancelOutlinedIcon fontSize='medium'/>}
                        >
                            <span className="panelDialogButtonText">Cancel upload</span>
                        </Button>
                        
                        </div>
                    :
// {/* --- video is NOT uploading */}    
// --- full length record mode (left side)
                        (isFullMatchMode ?
                            <div className="videosContainer">
                            
                            
                            
                            {feedFullMatchVideo ?
                            
                            
                            
                            <div>
                                
                                
                                {/* is Confirmed? */}
                                {feedFullMatchVideo.id ? 
                                
// --- full-length mode: full-length exists and IS CONFIRMED
    <div className="videoContainer">
    <SemanticDivider horizontal>
        <span className="dividerText">
            <Icon name="play circle outline" />
            Full-length match record for {this.props.FEEDS[this.props.feed]}
        </span>
    </SemanticDivider>

    <div className='panelDialogVideoPlayerBlock' onContextMenu={this.handleRightClick}>
        <HtmlTooltip
            title={
                <React.Fragment>
                    Full-length record will be visible to assigned clients until this day and time (unless this date is modified individually per client)
                </React.Fragment>
            }
            placement="top"
        >
            <div className='panelDialogVideoControlButtons'>
                <Button
                    variant="contained"
                    size="small"
                    disableElevation
                    disabled
                    className={isFullMatchVideoVisible ? "panelDialogButton videoControlsButtonFullSizeVisible" : "panelDialogButton videoControlsButtonFullSizeNotVisible"}
                    startIcon={isFullMatchVideoVisible ? <VisibilityIcon fontSize='medium'/> : <VisibilityOffIcon  fontSize='medium'/>}
                >
                    {isFullMatchVideoVisible ? <span className="panelDialogButtonTextFullLength">Visible until</span> :
                    <span className="panelDialogButtonTextFullLength">Not visible</span> }
                </Button>
                    <div className="datepickerDiv">
                    <Datepicker key={feedFullMatchVideo.id} video={feedFullMatchVideo}
                        label="Last availability date" matchDate={feedFullMatchVideo ? feedFullMatchVideo.bucket : this.state.matchInfo.date}
                        handleChangeDatepicker={this.handleChangeDatepicker} /> 
                    </div>
                
            </div>
            </HtmlTooltip>

            <VideoPlayer key={feedFullMatchVideo.signedUrl+feedFullMatchVideo.feedNumber} 
                
                watermark={true} videoSrc={feedFullMatchVideo.signedUrl} 
                poster={'/' + THEME + '/poster.png'}
            />
        </div>  {/* videoPlayerBlock ends */}
                                
    </div> 
                            
    :

// --- full-length mode: full-length exists and IS NOT CONFIRMED
    <div className="videoContainer">
    <SemanticDivider horizontal>
        <span className="dividerText">
            <Icon name="play circle outline" />
            Unconfirmed auto-uploaded full-length match record for {this.props.FEEDS[this.props.feed]}
        </span>
    </SemanticDivider>

    <div className='panelDialogVideoPlayerBlock' onContextMenu={this.handleRightClick}>
        <HtmlTooltip
            title={
                <React.Fragment>
                    This full-length record was uploaded automatically. Confirm this video to be able to assign it to clients. Alternatively, you can manually upload a video for this feed
                </React.Fragment>
            }
            placement="top"
        >
            
            <div className='panelDialogVideoControlButtons'>
                <Button
                    variant="contained"
                    size="small"
                    disableElevation
                    disabled
                    className="videoControlsButtonFullSizeNotConfirmed"
                    startIcon={<PauseCircleOutlineOutlinedIcon fontSize='medium'/>}
                >
                    <span className="panelDialogButtonTextFullLength">Not confirmed</span> 
                </Button>            
            </div>
        </HtmlTooltip>
            <div className='panelDialogVideoControlButtons'>
                <Button
                    variant="contained"
                    component="label"
                    size="small"
                    disableElevation
                    className="panelDialogButton confirmVideoButton greenColor"
                    startIcon={<CheckCircleOutlineOutlinedIcon fontSize='medium'/>}
                    onClick={() => this.handleConfirmAutoUploadVideo(feedFullMatchVideo.signedUrl)}
                >
                    <span className="panelDialogButtonText">Confirm video</span>
                </Button>
                <Button
                    variant="contained"
                    component="label"
                    size="small"
                    disableElevation
                    className="panelDialogButton confirmVideoButton redBackgroundButton"
                    startIcon={<RemoveCircleOutlineOutlinedIcon fontSize='medium'/>}
                    onClick={() => this.handleManualUploadMode(feedFullMatchVideo.signedUrl)}
                >
                    <span className="panelDialogButtonText">Upload manually</span>
                </Button>
            </div>

        <VideoPlayer key={feedFullMatchVideo.signedUrl+feedFullMatchVideo.feedNumber} 
            watermark={true} videoSrc={feedFullMatchVideo.signedUrl} 
            poster='/question-mark3.png'
        />
    </div>  {/* videoPlayerBlock ends */}
                            
    </div> //{/* videoContainer ends */}
    } 

</div>
                            
                            
                            
                            
                            :
// --- full-length mode: no full-length video
                            <Message
                            icon='video play'
                            size='large'
                            className='noVideosImagesMessage'
                            content={'No full-length match record have been uploaded yet for ' + this.props.FEEDS[this.props.feed]}
                            />
                            }        
                            </div>
                            
                            :






// --- highlight mode: video for client EXISTS
                            (userHasVideo ?
                            <div className="videosContainer">
                            
                            {currentVideos.map((video, index) =>
                            
                            <div className="videoContainer" id={index} key={video.key}>
                                <SemanticDivider horizontal>
                                    <span className="dividerText">
                                        <Icon name="play circle outline" />
                                        {video.extra !== "F" ? 
                                            (video.id ?
                                                `Highlight video for ${companyName} (${index+1} of ${highlightVideoNumber})`
                                                :
                                                `Unconfirmed highlight for ${companyName}`
                                            )
                                            :
                                            `Full match record for ${this.props.FEEDS[this.props.feed]} (visible to ${companyName})`
                                        }
                                    </span>
                                </SemanticDivider>                                

{/* --- highlight mode: full-length video assigned to client   */}
    {video.extra === 'F' ?
        <HtmlTooltip
            title={
                <React.Fragment>
                    {isFullMatchVideoVisible ?
                    <span>Full-length record is <span className="greenColor">visible</span> to {companyName} up to this day and including. Click on the date box to modify the period of full-length video visibility for this client</span>
                    :
                    <span>Full-length record is <span className="red">not visible</span> anymore to {companyName}. Click on the datepicker box to extend the period of full-length video visibility for this client</span>
                    }
                </React.Fragment>
            }
            placement="top"
        >
            <div className='panelDialogVideoControlButtons'>
                <Button
                    variant="contained"
                    size="small"
                    disableElevation
                    disabled
                    className={isFullMatchVideoVisible ? "panelDialogButton videoControlsButtonFullSizeVisible" : "panelDialogButton videoControlsButtonFullSizeNotVisible"}
                    startIcon={isFullMatchVideoVisible ? <VisibilityIcon fontSize='medium'/> : <VisibilityOffIcon  fontSize='medium'/>}
                >
                    {isFullMatchVideoVisible ? <span className="panelDialogButtonTextFullLength">Visible until</span> :
                    <span className="panelDialogButtonTextFullLength">Not visible</span> }
                </Button>
                <div className="datepickerDiv">
                <Datepicker key={video.id} video={video}
                    label="Last availability date" matchDate={video.bucket ? video.bucket : this.state.matchInfo.date}
                    handleChangeDatepicker={this.handleChangeDatepicker} /> 
                </div>
            </div>
            </HtmlTooltip> 
                
// --- HIGHLIGHT MODE: highlight video EXISTS and IS CONFIRMED

                :
                (video.id ?
                <div className='panelDialogVideoControlButtons'>          
                <Button
                    variant="contained"
                    size="small"
                    disableElevation
                    disabled
                    className="panelDialogButton videoControlsButton"
                    startIcon={<FeaturedVideoOutlinedIcon fontSize='medium'/>}
                >
                    <span className="panelDialogButtonText">Highlight</span>
                </Button>
                <Tooltip title="Deactivate this highlight video" placement="top" arrow>
                <Button
                        variant="contained"
                        size="small"
                        disableElevation
                        disabled={video.extra === "F"}
                        onClick={() => this.openConfirmDeleteVideo(video)}
                        className="panelDialogButtonDelete videoControlsButton"
                        startIcon={<RemoveCircleOutlineIcon fontSize='medium'/>}
                    >
                        <span className="panelDialogButtonText">Deactivate</span>
                </Button>
                </Tooltip>
                {/* <Button
                        variant="contained"
                        size="small"
                        disableElevation
                        disabled={video.extra === "F"}
                        onClick={() => this.testEmail(video)}
                        className="panelDialogButtonDelete videoControlsButton"
                        startIcon={<RemoveCircleOutlineIcon fontSize='medium'/>}
                    >
                        <span className="panelDialogButtonText">EMAIL</span>
                </Button> */}
                </div>
                :
                
// --- HIGHLIGHT MODE: highlight video is NOT CONFIRMED
// unconfirmed highlight -> upper buttons                
                
    <div>
        <HtmlTooltip
            title={
                <React.Fragment>
                    This highlight was generated automatically. Click <i>Confirm highlight</i> to make it visible to clients. Alternatively, you can manually upload a highlight video for this client and feed
                </React.Fragment>
            }
            placement="top"
        >
            <div className='panelDialogVideoControlButtons'>
                <Button
                    variant="contained"
                    size="small"
                    disableElevation
                    disabled
                    className="videoControlsButtonFullSizeNotConfirmed"
                    startIcon={<PauseCircleOutlineOutlinedIcon fontSize='medium'/>}
                >  
                    <span className="panelDialogButtonTextFullLength">Not confirmed</span> 
                </Button>            
            </div>
        </HtmlTooltip>

        <div className='panelDialogVideoControlButtons'>
            <Button
                variant="contained"
                component="label"
                size="small"
                disableElevation
                className="panelDialogButton confirmVideoButton greenColor"
                startIcon={<CheckCircleOutlineOutlinedIcon fontSize='medium'/>}
                onClick={() => this.handleConfirmAutoUploadVideo(video.signedUrl)}
            >
                <span className="panelDialogButtonText">Confirm highlight</span>
            </Button>
            <Button
                variant="contained"
                component="label"
                size="small"
                disableElevation
                className="panelDialogButton confirmVideoButton redBackgroundButton"
                startIcon={<RemoveCircleOutlineOutlinedIcon fontSize='medium'/>}
                onClick={() => this.handleManualUploadMode(video.signedUrl)}
            >
                <span className="panelDialogButtonText">Upload manually</span>
            </Button>
        </div>
    </div>
    )              
    // unconfirmed highligth upper buttons end
                }

                                <div className='panelDialogVideoPlayerBlock' onContextMenu={this.handleRightClick}>

                                <VideoPlayer key={video.signedUrl+video.feedNumber} 
                                    watermark={video.extra === 'F'} videoSrc={video.signedUrl} 
                                    poster={video.id ? '/' + THEME + '/poster.png' : '/question-mark3.png'}
                                />
                                </div>
                            </div>
                            )}    
                            </div>
                        :
                        <Message
                            icon='video play'
                            size='large'
                            className='noVideosImagesMessage'
                            content={'No video for ' + companyName + ' in this feed'}
                        />
                        )
                    )
                    }

                    </div>
// --- videoView left side for managers ends
                    
                    :

// --- MANAGER - LEFT - IMAGE

                    // imageView left side for managers begins
                    <div className="galleryViewLeftSide">
                        {currentGalleryImages.length > 0 ?
                        <ImageGallery onScreenChange={this._onScreenChange} 
                            onSlide={() => this.onSlide()} 
                            ref={i => this._imageGallery = i}
                            items={currentGalleryImages} 
                        />
                        :
                        <Message
                            icon='images'
                            size='large'
                            className='noVideosImagesMessage'
                            content={'No images for ' + companyName + ' in this feed'}
                        />
                        }  
                    </div>
                    // imageView left side for managers ends
                    }
                    

                    
{/* // MANAGER RIGHT UPPER PART      zzz 0              */}


<div className="galleryViewRightSide">

    <Tooltip title="Change view" placement="bottom" arrow>
        <div className="galleryViewButtons">            
            <a onClick={() => this.changeViewLabelClick(false)} className={videoView ? "ui label" : "ui teal label"}>
                <i aria-hidden="true" className="images outline icon"></i> Images
            </a>

            <Switch className="panelDialogSwitchTop" currentView={videoView} change={this.changeView} />
            {/* <span className="switchOptions">Video</span> */}
            <a onClick={() => this.changeViewLabelClick(true)} className={videoView ? "ui teal label" : "ui label"}>
                <i aria-hidden="true" className="play circle outline icon"></i> Videos
            </a>
        </div>
    </Tooltip>

    <SemanticDivider horizontal>
    <span className="dividerText">
        <Icon name='bar chart' />
        {matchInfo.details}
    </span>
    </SemanticDivider>

    <div className="galleryViewMatchInfo">
        {minuteAllocation ?
        <Table rows={[
            [ "Date", moment(matchInfo.date).format('D MMMM YYYY') ],
            [ "Kick-off", this.props.kickoff ],
            [ "Feed", this.props.FEEDS[this.props.feed] ],
            [ "Minutes sold", soldMinutes ],
            [ "Minutes played", playedMinutes ],
            ]}/>
        :
        <Table rows={[
            [ "Date", moment(matchInfo.date).format('D MMMM YYYY') ],
            [ "Kick-off", this.props.kickoff ],
            [ "Feed", this.props.FEEDS[this.props.feed] ],
            ]}/>
        }
    </div>

    {/* zzzzz */}
    {videoView &&

    <div className="galleryViewButtons">
        <SemanticDivider horizontal>
        <span className="dividerText">
            <Icon name='play circle outline' className='lowOpacityIcon' />
            Full-length match record
        </span>
        </SemanticDivider>
        {isFullMatchMode ? 
        <Button
            variant="contained"
            component="label"
            size="small"
            disableElevation
            className="panelDialogButtonAddImageWide"
            startIcon={<FeaturedVideoOutlinedIcon fontSize='medium'/>}
            onClick={this.handleChangeFullMatchMode}
        >
            <span className="panelDialogButtonText">Back to Highlight videos mode</span>
        </Button>
        :
        <HtmlTooltip
            title={
                <React.Fragment>
                        Click to enter the Full-length record view, where you can upload/delete full-length video for this feed and assign it to clients. 
                </React.Fragment>
            }
        >
        <Button
            variant="contained"
            component="label"
            size="small"
            disableElevation
            className="panelDialogButtonAddImageWide panelNewFullmatchMode"
            startIcon={<VideocamOutlinedIcon fontSize='medium'/>}
            onClick={this.handleChangeFullMatchMode}
        >
            <span className="panelDialogButtonText">Go to full-length record for {this.props.FEEDS[this.props.feed]}</span>
        </Button>
        </HtmlTooltip>
        }
    </div>
    }

    {isFullMatchMode && videoView ? 
    <span></span>
    :
    <span>
    <SemanticDivider horizontal>
        <span className="dividerText">
            <Icon name='user outline' className='lowOpacityIcon' />
            Client
        </span>
    </SemanticDivider>

    <div className="galleryViewButtons">
        <Dropdown
            onChange={this.handleChangeDropdown}
            options={this.dropdownCompanies}
            placeholder='Select client'
            button
            scrolling
            value={value}
        />
    </div>
    </span>
    }
    

{videoView ? 

// MANAGER RIGHT (LOWER PART) VIDEO

    <React.Fragment>
        {value && 
        <React.Fragment>
            <div className="galleryViewButtons">
                {isFullMatchMode && feedFullMatchVideo ?
                <div>
                    {/* is full-match video confirmed */}
                    {feedFullMatchVideo.id &&
                    <div>
                    <HtmlTooltip
                        title={
                            <React.Fragment>
                                    Click on the dropdown list and add (or remove) clients to whom you want to assign full-length record. Then click [Save assignment] button to confirm.
                            </React.Fragment>
                        }
                        placement="top"
                    >
                        <span className="panelNewLabel">Assigned to clients &nbsp; <Icon size="small" 
                        name='info circle'/>
                        </span>
                    </HtmlTooltip>
                    <Dropdown key={this.props.feed} placeholder='Assign to clients' className="assignToClientsDropdown" 
                        onChange={this.handleSelectClientsToAssign.bind(this)}
                        fluid multiple selection options={this.dropdownCompanies} 
                        defaultValue={this.state.clientsAssignedToFullVideo[feed-1]}
                    />
                    <Button
                        onClick={() => this.handleAssignFullmatchVideoToClients(feedFullMatchVideo)}
                        variant="contained"
                        size="small"
                        disableElevation
                        // disabled={ selectedVideo.size ? false : true }
                        className={"panelDialogButton widerButton"}
                        startIcon={<SaveOutlinedIcon fontSize='medium'/>}
                    >
                        <span className="panelDialogButtonText">Save assignment</span>
                    </Button>
                <Tooltip title={`Delete full-length record for ${this.props.FEEDS[this.props.feed]}`} placement="bottom" arrow>
                <Button
                        variant="contained"
                        size="small"
                        disableElevation
                        // disabled
                        // color={"#55b6cc"}
                        onClick={() => this.openConfirmDeleteVideo(feedFullMatchVideo)}
                        className="panelDialogButtonDelete videoControlsButton panelButtonDisabled"
                        startIcon={<DeleteOutlineIcon fontSize='medium'/>}
                    >
                        <span className="panelDialogButtonText">Delete</span>
                </Button>
                </Tooltip>
                </div>
                }
                </div>
                :
                <Button
                    variant="contained"
                    component="label"
                    size="small"
                    disableElevation
                    className="panelDialogButtonAddImageWide"
                    startIcon={<AddIcon fontSize='medium'/>}
                >
                    {isFullMatchMode ?
                        <span className="panelDialogButtonText">
                        Select full-length record for {this.props.FEEDS[this.props.feed]}
                        </span>
                    :
                        <span className="panelDialogButtonText">
                        Select highlight for {companyName}
                        </span>
                    }
                <input
                    style={{display:'none'}}
                    accept={"video/*"}
                    type={"file"}
                    ref={this.fileInput}
                    onChange={ (e) => this.handleSelectVideo(e.target.files[0]) }
                    // https://stackoverflow.com/questions/39484895/how-to-allow-input-type-file-to-select-the-same-file-in-react-component/40429197
                    onClick={(event)=> { 
                        event.target.value = null
                   }}
                />
            </Button>
            }
            </div>
            
        {selectedVideo.size &&
            // video was selected (before upload button was clicked)
            <span>
                <SemanticDivider horizontal>
                    <span className="dividerText">
                        <Icon name="play circle outline" />
                        {"Video"}
                    </span>
                </SemanticDivider>
                
                <div className="galleryViewButtons">
                    <Table rows={[
                        [ "Type", isFullMatchMode ? "Full-length record" : "Highlight video" ],
                        [ "Name", selectedVideo.name ],
                        [ "Modified", selectedVideo.modified ? moment(selectedVideo.modified).format('D MMMM YYYY HH:MM') : "" ],
                        [ "Size", selectedVideo.size ],
                    ]}/>
                </div>
                {!this.state.uploading &&
                <React.Fragment>
                {/* <div className="galleryViewButtons">
                    <FormControlLabel
                        control={<Checkbox checked={this.state.isFullMatchMode} color="primary"
                            onChange={this.handleChangeCheckbox} name="isFullMatchMode" />}
                            label="Video is a full match record"
                    />
                </div> */}
                <div className="galleryViewButtons">
                    <Button
                        onClick={() => this.handleUploadVideo(this.fileInput)}
                        variant="contained"
                        size="small"
                        disableElevation
                        disabled={ selectedVideo.size ? false : true }
                        className={selectedVideo.size ? "panelDialogButton" : "panelDialogButton panelButtonDisabled"}
                        startIcon={<CloudUploadOutlinedIcon fontSize='medium'/>}
                    >
                        <span className="panelDialogButtonText">Upload video</span>
                    </Button>
                    <Button
                        onClick={this.handleRemoveSelection}
                        variant="contained"
                        size="small"
                        disableElevation
                        disabled={ selectedVideo.size ? false : true }
                        className={selectedVideo.size ? "panelDialogButtonRight" : "panelDialogButtonRight panelButtonDisabled"}
                        startIcon={<CancelOutlinedIcon fontSize='medium'/>}
                    >
                        <span className="panelDialogButtonText">Cancel</span>
                    </Button>
                </div>
                </React.Fragment>
                }
            </span>
        }
    
    </React.Fragment> }
    

    </React.Fragment>
    // Video right side lower part for Manager ends

    :
    
    // Image info/buttons for Manager starts
    <React.Fragment>


    <div className="galleryViewButtons">
        {value &&
            <Button
            variant="contained"
            // more info on "component=label": https://stackoverflow.com/questions/40589302/how-to-enable-file-upload-on-reacts-material-ui-simple-input
            component="label"
            size="small"
            disableElevation
            className="panelDialogButtonAddImageWide"
            startIcon={<AddIcon fontSize='medium'/>}
        >
            <span className="panelDialogButtonText">Add image for {companyName}</span>
            <input
                style={{display:'none'}}
                accept={"image/*"}
                type={"file"}
                onChange={ (e) => this.handleAddImage(e.target.files) }
                multiple
            />
        </Button>
        }
    </div>

    {feedHasImages && activeGalleryImageInfo &&
    <React.Fragment>
    <SemanticDivider horizontal>
    <span className="dividerText">
        <Icon name='image' />
        {"Image (" + (index + 1) + "/" + currentGalleryImages.length + ")"}
    </span>
    </SemanticDivider>

    <div className="galleryViewImageInfo">
        <Table rows={[
                [ "File", activeGalleryImageInfo.name ],
                [ "Size", activeGalleryImageInfo.size ],
                [ "Dimensions", activeGalleryImageInfo.resolution ],
                ]}
        />
    </div>

    <div className="galleryViewButtons">
        <span onClick={() => this.handleDownloadZip(false)}>
            <Button
                variant="contained"
                size="small"
                disableElevation
                // color={"#55b6cc"}
                className="panelDialogButton"
                startIcon={<SaveAltIcon fontSize='medium'/>}
            >
                <span className="panelDialogButtonText">Match images</span>
            </Button>
        </span>
        <span onClick={() => this.handleDownloadZip(true)}>
            <Button
                variant="contained"
                size="small"
                disableElevation
                // color={"#55b6cc"}
                className={this.props.user.isManager ? "panelDialogButtonRight": "panelDialogButton"}
                startIcon={<SaveAltIcon fontSize='medium'/>}
            >
                <span className="panelDialogButtonText">Feed images</span>
            </Button>
        </span>
    </div>


    <div className="galleryViewButtons">

        <span onClick={() => this.handleDownloadImage(activeGalleryImageInfo.id)}>
            <Button
                variant="contained"
                size="small"
                disableElevation
                className="panelDialogButton"
                startIcon={<SaveAltIcon fontSize='medium'/>}
            >
                <span className="panelDialogButtonText">This image</span>
            </Button>
        </span>
        {this.props.user.isManager &&
        <span onClick={() => this.openConfirmDelete()}>
            <Button
                variant="contained"
                size="small"
                disableElevation

                className="panelDialogButtonDelete"
                startIcon={<DeleteOutlineIcon fontSize='medium'/>}
            >
                <span className="panelDialogButtonText">Delete image</span>
            </Button>
        </span>       
        }
    </div>

    </React.Fragment>}
</React.Fragment>
// IMAGE VIEW ENDS
}
</div>


</div>
                  //  {/* // MANAGER VIEW ENDS */}


                    :
                    
                
                 // {/* // CLIENT VIEW */}

<div className="galleryViewPanelDialogMain">
    
{/* // CLIENT - LEFT - VIDEO */}

    {videoView ?
    <div className="galleryViewLeftSide">
                        {userHasVideo ?
                            <div className="videosContainer">
                            
                            {currentVideos.map((video) =>
                            <span key={video.id}>
                                {/* <SemanticDivider horizontal>
                                    <span className="dividerText">
                                        <Icon name="play circle outline" />
                                        {video.company ? `Video for ${companyName}` : "Visible to all clients"}
                                    </span>
                                </SemanticDivider> */}
                                {/* {video.link ?
                                <Embed
                                    className="videoPlayerContainer"
                                    source="vimeo"
                                    iframe={{
                                        allowFullScreen: true,
                                    }}
                                    placeholder={process.env.PUBLIC_URL + '/sportfive_logo_transparent.png'}
                                    id={video.link}
                                />
                                : */}
                                {/* <video key={video.signedUrl} 
                                    preload="none" ref={this.videoRef} 
                                    poster={process.env.PUBLIC_URL + '/sportfive_logo_transparent.png'} onContextMenu={this.handleRightClick} width="512" height="380" controls controlsList="nodownload"
                                >
                                    <source 
                                    src={video.signedUrl}
                                    // src={CLOUDFRONT_DOMAIN_NAME + video.key} 
                                    type="video/mp4" />
                                </video> */}
                                <VideoPlayer key={video.signedUrl+video.feedNumber} 
                                    watermark={false} videoSrc={video.signedUrl} 
                                    poster={'/' + THEME + '/poster.png'}
                                />

                                {/* } */}
                            </span>
                            )}    
                            </div>
                        :
                        <Message
                            icon='video play'
                            size='large'
                            className='noVideosImagesMessage'
                            content={'No video for ' + companyName + ' in this feed'}
                        />
                    }
                    

                    </div>
                    // {/* // videoView left side for clients ends */}
                    
                    :

// {/* // CLIENT - LEFT - IMAGE */}

                    // imageView left side for managers begins
                    <div className="galleryViewLeftSide">
                        {currentGalleryImages.length > 0 ?
                        <ImageGallery onScreenChange={this._onScreenChange} 
                            onSlide={() => this.onSlide()} 
                            ref={this.setImageRef}
                            ref={i => this._imageGallery = i}
                            items={currentGalleryImages} 
                        />
                        :
                        <Message
                            icon='images'
                            size='large'
                            className='noVideosImagesMessage'
                            content={'No images in this feed'}
                        />
                        }  
                    </div>
                    // imageView left side for clients ends
                    }


                    
{/* CLIENT RIGHT  */}
                    <div className="galleryViewRightSide">
                        <Tooltip title="Change view" placement="bottom" arrow>
                            <div className="galleryViewButtons">            
                                <a onClick={() => this.changeViewLabelClick(false)} className={videoView ? "ui label" : "ui teal label"}>
                                    <i aria-hidden="true" className="images outline icon"></i> Images
                                </a>

                                <Switch className="panelDialogSwitchTop" currentView={videoView} change={this.changeView} />
                                {/* <span className="switchOptions">Video</span> */}
                                <a onClick={() => this.changeViewLabelClick(true)} className={videoView ? "ui teal label" : "ui label"}>
                                    <i aria-hidden="true" className="play circle outline icon"></i> Videos
                                </a>
                            </div>
                        </Tooltip>
                        
                        <SemanticDivider horizontal>
                        <span className="dividerText">
                            <Icon name='bar chart' />
                            Match
                        </span>
                        </SemanticDivider>
                        
                        <div className="galleryViewMatchInfo">
                            <Table rows={[
                                [ "Name", matchInfo.details ],
                                [ "Date", matchInfo.date ],
                                [ "Kick-off", this.props.kickoff ],
                                ]}/>
                        </div>
                            
                        {/* DON'T SHOW THIS BUTTON IN videoView MODE */}
                        {feedHasImages &&  !videoView &&
                        <div className="galleryViewButtons">
                            <span onClick={() => this.handleDownloadZip(false)}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    disableElevation
                                    className="panelDialogButtonLong"
                                    startIcon={<SaveAltIcon fontSize='medium'/>}
                                >
                                    <span className="panelDialogButtonText">Download all match images</span>
                                </Button>
                            </span>
                        </div>
                        }

                        <SemanticDivider horizontal>
                            <span className="dividerText">
                                <Icon name='map marker alternate' className='lowOpacityIcon' />
                                Feed
                            </span>
                        </SemanticDivider>
                        
                        <div className="galleryViewMatchInfo">
                            <Table 
                                cellClass="panelDialogFeedTableCell"
                                rows={[
                                    [ "Region", this.props.FEEDS[this.props.feed] ],
                                    ]}
                            />
                        </div>

                        {/* DON'T SHOW Feed images BUTTON IN videoView MODE */}
                        <div className="galleryViewButtons">
                            {feedHasImages > 0 && !videoView &&
                            <span onClick={() => this.handleDownloadZip(true)}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    disableElevation
                                    className={this.props.user.isManager ? "panelDialogButtonRight": "panelDialogButton"}
                                    startIcon={<SaveAltIcon fontSize='medium'/>}
                                >
                                    <span className="panelDialogButtonText">Feed images</span>
                                </Button>
                            </span>
                            }
                        </div>
                    
                    {feedHasImages && activeGalleryImageInfo && !videoView &&
                        <span>
                        <SemanticDivider horizontal>
                        <span className="dividerText">
                            <Icon name='image' />
                            {"Image (" + (index + 1) + "/" + currentGalleryImages.length + ")"}
                        </span>
                        </SemanticDivider>
                        
                        <div className="galleryViewImageInfo">
                            <Table rows={[
                                    [ "File", activeGalleryImageInfo.name ],
                                    [ "Size", activeGalleryImageInfo.size ],
                                    [ "Dimensions", activeGalleryImageInfo.resolution ],
                                    ]}
                            />

                        <div className="galleryViewButtons">
                            <span onClick={() => this.handleDownloadImage(activeGalleryImageInfo.id)}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    disableElevation
                                    // color={"#55b6cc"}
                                    className="panelDialogButton"
                                    startIcon={<SaveAltIcon fontSize='medium'/>}
                                >
                                    <span className="panelDialogButtonText">This image</span>
                                </Button>
                            </span>
                        </div>
                        {/* <SemanticDivider horizontal>
                        <span className="dividerText">
                            
                        </span>
                        </SemanticDivider> */}

                        </div>
                        </span>}
                    </div></div>}
                    {/* above !isManager block ends */}

                    
                    {/* MODAL WINDOWS below */}

            {feedHasImages && this.state.openConfirm &&
            <Dialog open={this.state.openConfirm} TransitionComponent={Transition} onClose={this.closeConfirmDelete} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">
                    Delete image
                </DialogTitle>
                <DialogContent>
                <DialogContentText>
                    File <span className="red">'{activeGalleryImageInfo.name}'</span> will be permanently deleted. Continue?
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={this.closeConfirmDelete} color="primary">
                    Cancel
                </Button>
                <Button className="red" onClick={(event) => this.handleDeleteImage(activeGalleryImageInfo.id)} color="secondary">
                    Delete
                </Button>
                </DialogActions>
            </Dialog>
            }
            {this.state.openConfirmVideo &&
            <Dialog open={this.state.openConfirmVideo} TransitionComponent={Transition} onClose={this.closeConfirmDeleteVideo} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">
                    Delete video
                </DialogTitle>
                <DialogContent>
                {isFullMatchMode ?
                <DialogContentText>
                    Do you really want to delete full-length match record for {this.props.FEEDS[this.props.feed]}?
                </DialogContentText>
                :
                <DialogContentText>
                Video for <span className="red"> {companyName} </span> in this feed will be removed. Continue?
                </DialogContentText>
                }
                </DialogContent>
                <DialogActions>
                <Button onClick={this.closeConfirmDeleteVideo} color="primary">
                    Cancel
                </Button>
                <Button className="red" onClick={(event) => this.handleDeleteVideo(currentVideos)} color="secondary">
                    Delete
                </Button>
                </DialogActions>
            </Dialog>
            }
            {/* {this.state.openAddVimeoVideo &&
            <Dialog open={this.state.openAddVimeoVideo} TransitionComponent={Transition} onClose={this.closeAddVimeoVideo} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add a Vimeo link</DialogTitle>
                <DialogContent>
                <DialogContentText>
                    This video will be visible to {companyName}.
                </DialogContentText>
                <TextField
                    inputRef={c => this.nameRef = c}
                    required
                    margin="dense"
                    id="name"
                    label="Vimeo link"
                    // type="email"
                    fullWidth
                />
                </DialogContent>
                <DialogActions>
                <Button onClick={this.closeAddVimeoVideo} color="primary">
                    Cancel
                </Button>
                <Button onClick={() => this.handleAddVimeoVideo(this.nameRef.value)} color="primary">
                    Add video
                </Button>
                </DialogActions>
            </Dialog>
            } */}

            </div> 
        );
    }
    }
}
export default Panel;